import { ChartGuide } from '../hooks/useChartGuide';

export const CHART_GUIDES: Record<string, ChartGuide> = {
  // Sales and Financial Charts
  monthlySalesComparison: {
    title: 'راهنمای نمودار مقایسه فروش ماهیانه',
    description: 'این نمودار میله‌ای، عملکرد فروش شعبه شما را در ماه‌های مختلف نمایش می‌دهد و امکان مقایسه با میانگین برند را فراهم می‌کند.',
    interpretation: 'میله‌های بلندتر نشان‌دهنده فروش بیشتر هستند. با مقایسه میله‌های شعبه خود با میانگین برند، می‌توانید عملکرد نسبی خود را ارزیابی کنید.',
    tips: [
      'به ماه‌هایی که فروش کمتر از میانگین برند دارید توجه ویژه کنید',
      'الگوهای فصلی را شناسایی کرده و برای آن‌ها برنامه‌ریزی کنید',
      'در ماه‌های پرفروش، از تجربیات موفق خود یادداشت‌برداری کنید'
    ]
  },

  salesTrend: {
    title: 'راهنمای نمودار روند فروش',
    description: 'این نمودار خطی، روند تغییرات فروش و تعداد سفارش‌ها را در طول زمان نشان می‌دهد.',
    interpretation: 'خط صعودی نشان‌دهنده رشد و خط نزولی نشان‌دهنده کاهش است. شیب خط میزان سرعت تغییرات را نشان می‌دهد.',
    tips: [
      'به نقاط عطف (تغییر جهت روند) توجه کنید',
      'روند بلندمدت را از نوسانات کوتاه‌مدت تفکیک کنید',
      'همبستگی بین تعداد سفارش و مبلغ فروش را بررسی کنید'
    ]
  },

  salesAmountTrend: {
    title: 'راهنمای نمودار روند مبلغ فروش',
    description: 'این نمودار تغییرات مبلغ فروش را در دوره‌های زمانی مختلف نمایش می‌دهد.',
    interpretation: 'روند صعودی پایدار نشان‌دهنده سلامت مالی رستوران است. نوسانات شدید ممکن است نیاز به بررسی داشته باشد.',
    tips: [
      'میانگین فروش روزانه را محاسبه و با اهداف خود مقایسه کنید',
      'تأثیر تغییرات قیمت منو را بر روند فروش بررسی کنید',
      'روزهای پرفروش و کم‌فروش را شناسایی کنید'
    ]
  },

  invoiceCountTrend: {
    title: 'راهنمای نمودار روند تعداد سفارش',
    description: 'این نمودار میله‌ای تعداد سفارش‌های صادر شده در هر دوره را نشان می‌دهد.',
    interpretation: 'تعداد سفارش بیشتر معمولاً نشان‌دهنده ترافیک بیشتر مشتری است. کاهش این عدد می‌تواند هشداری برای بررسی دلایل باشد.',
    tips: [
      'نسبت تعداد سفارش به ظرفیت رستوران را محاسبه کنید',
      'ساعات شلوغی را شناسایی و برای آن‌ها برنامه‌ریزی کنید',
      'میانگین مبلغ هر سفارش را محاسبه و روند آن را پیگیری کنید'
    ]
  },

  // Customer Satisfaction Charts
  customerSatisfactionComparison: {
    title: 'راهنمای نمودار مقایسه رضایت مشتریان',
    description: 'این نمودار میله‌ای، نمره رضایت مشتریان شعبه شما را با میانگین برند مقایسه می‌کند.',
    interpretation: 'نمرات بالاتر (نزدیک به 5) نشان‌دهنده رضایت بیشتر است. فاصله با میانگین برند اهمیت دارد.',
    tips: [
      'نمره زیر 4 نیاز به بررسی فوری دارد',
      'از شعب با نمره بالاتر الگوبرداری کنید',
      'بازخوردهای مشتریان را برای بهبود نمره مطالعه کنید'
    ]
  },

  customerSatisfactionAnalysis: {
    title: 'راهنمای تحلیل رضایت مشتریان',
    description: 'این نمودار روند تغییرات رضایت مشتریان را در طول زمان نشان می‌دهد.',
    interpretation: 'ثبات در نمرات بالا مطلوب است. نوسانات شدید نشان‌دهنده عدم ثبات کیفیت خدمات است.',
    tips: [
      'تغییرات ناگهانی در نمره را با رویدادهای خاص مطابقت دهید',
      'اثر تغییرات پرسنل یا منو را بر رضایت بررسی کنید',
      'هدف‌گذاری برای بهبود مستمر نمره رضایت داشته باشید'
    ]
  },

  satisfactionByShift: {
    title: 'راهنمای رضایت بر اساس شیفت کاری',
    description: 'این نمودار رضایت مشتریان را در شیفت‌های مختلف کاری مقایسه می‌کند.',
    interpretation: 'تفاوت‌های چشمگیر بین شیفت‌ها می‌تواند نشان‌دهنده نیاز به آموزش یا تغییر در مدیریت شیفت باشد.',
    tips: [
      'کیفیت خدمات را در همه شیفت‌ها استاندارد کنید',
      'بهترین عملکردها را از شیفت‌های موفق به سایر شیفت‌ها منتقل کنید',
      'بررسی کنید آیا تفاوت در تعداد پرسنل یا تجربه آن‌ها تأثیرگذار است'
    ]
  },

  satisfactionByOrderType: {
    title: 'راهنمای رضایت بر اساس نوع سفارش',
    description: 'این نمودار رضایت مشتریان را برای انواع مختلف سفارش (حضوری، بیرون‌بر، آنلاین) نشان می‌دهد.',
    interpretation: 'تفاوت در رضایت انواع سفارش می‌تواند نقاط ضعف در فرآیندهای خاص را نشان دهد.',
    tips: [
      'برای هر نوع سفارش استانداردهای کیفیت تعریف کنید',
      'زمان آماده‌سازی و تحویل را برای هر نوع بهینه کنید',
      'بسته‌بندی و ارائه را متناسب با نوع سفارش طراحی کنید'
    ]
  },

  satisfactionTrend: {
    title: 'راهنمای نمودار روند رضایت مشتریان',
    description: 'این نمودار روند کلی رضایت مشتریان را در طول دوره زمانی انتخابی نمایش می‌دهد.',
    interpretation: 'خط صعودی نشان‌دهنده بهبود و خط نزولی نشان‌دهنده کاهش رضایت است. به شیب تغییرات توجه کنید.',
    tips: [
      'روند کلی را با رویدادهای مهم رستوران مطابقت دهید',
      'نقاط افت و خیز را شناسایی و علل آن‌ها را بررسی کنید',
      'از داده‌ها برای پیش‌بینی و برنامه‌ریزی آینده استفاده کنید'
    ]
  },

  satisfactionByCategory: {
    title: 'راهنمای شاخص‌های رضایت به تفکیک دسته‌بندی',
    description: 'این نمودار رضایت مشتریان را در دسته‌های مختلف مانند کیفیت غذا، خدمات، قیمت و محیط نشان می‌دهد.',
    interpretation: 'هر دسته نقاط قوت و ضعف رستوران را نشان می‌دهد. دسته‌های با نمره پایین نیاز به توجه فوری دارند.',
    tips: [
      'بر دسته‌هایی با کمترین نمره تمرکز کنید',
      'نقاط قوت خود را حفظ و تقویت کنید',
      'برای هر دسته برنامه بهبود جداگانه تدوین کنید'
    ]
  },

  // Product and Category Charts
  productCategories: {
    title: 'راهنمای نمودار دسته‌بندی محصولات',
    description: 'این نمودار دایره‌ای سهم فروش هر دسته محصول را از کل فروش نشان می‌دهد.',
    interpretation: 'بخش‌های بزرگ‌تر نشان‌دهنده دسته‌های پرفروش‌تر هستند. تعادل بین دسته‌ها مهم است.',
    tips: [
      'دسته‌های با سهم کم را برای افزایش فروش بررسی کنید',
      'از دسته‌های پرفروش برای جذب مشتری استفاده کنید',
      'حاشیه سود هر دسته را در کنار سهم فروش در نظر بگیرید'
    ]
  },

  // Customer Retention
  customerRetention: {
    title: 'راهنمای نمودار «تحلیل حفظ مشتریان»',
    description: 'این نمودار نشان می‌دهد به‌طور کلی در هر ماه، رستوران در حال جذب خالص مشتری است یا در حال از دست دادن آن‌ها. سه ستون هر ماه (مشتریان قدیمی، مشتریان جدید، مشتریان غیرفعال) اجزای این تصویرند، و خط زرد روی نمودار، خلاصه نهایی و حاصل جمع این اجزا در قالب یک عدد واحد به نام «رشد مشتریان» است.',
    interpretation: 'مشتریان جدید: کسانی که برای اولین بار در آن ماه از رستوران خرید کرده‌اند. مشتریان قدیمی: مشتریانی که سابقه خرید قبلی داشته‌اند و در همان ماه هم دوباره خرید کرده‌اند؛ یعنی مشتریانی که رستوران توانسته آن‌ها را حفظ کند. مشتریان غیرفعال: مشتریانی که دقیقاً در همان ماه، یک سال کامل از آخرین خریدشان می‌گذرد و در این یک سال هیچ خرید دیگری ثبت نکرده‌اند؛ یعنی کسانی که در همین ماه، رسماً وارد وضعیت «غیرفعال» شده‌اند. فرمول رشد مشتریان: رشد مشتریان = کل مشتریان ماه − مشتریان از دست‌رفته همان ماه. مشتری جدید و بازگشت مشتری قدیمی به رشد این نمودار کمک می‌کند؛ رسیدن مشتریان قدیمی به آستانه یک سال بدون خرید (تبدیل شدنشان به مشتری غیرفعال) باعث افت این نمودار می‌شود.',
    sections: [
      {
        title: 'چرا این نمودار مهم است؟',
        style: 'none',
        items: [
          'این نمودار در یک نگاه، اثر خالص سه نیروی متضاد را روی هم نشان می‌دهد: جذب (مشتری جدید)، بازگشت (مشتری قدیمی که دوباره خرید کرده) و ریزش (مشتری قدیمی که از دست رفته). به‌جای اینکه این سه عدد را جدا جدا و پراکنده در جاهای مختلف دنبال کنید، خط زرد یک جمع‌بندی واحد از سلامت کلی رابطه رستوران با مشتریانش ارائه می‌دهد.',
        ],
      },
      {
        title: 'چگونه خوانده شود؟',
        style: 'bullet',
        items: [
          'مثبت: تعداد مشتریانی که به چرخه خرید اضافه یا از میان مشتریان از دست‌رفته بازگردانده شده‌اند، بیشتر از تعداد مشتریانی است که از دست رفته‌اند.',
          'نزدیک به صفر: جذب و نگهداشت مشتری، با ریزش مشتری در یک تعادل ناپایدار قرار گرفته؛ رستوران دارد دقیقاً به همان اندازه‌ای که مشتری از دست می‌دهد، مشتری جایگزین می‌کند، بدون رشد واقعی.',
          'منفی: سرعت از دست دادن مشتری، از سرعت بازگشت و جذب مشتری بیشتر بوده است. این حالت می‌تواند به دلایلی مانند افزایش قیمت، نارضایتی مشتری، افت کیفیت غذا یا خدمات، یا ورود رقبای تازه به بازار باشد.',
        ],
      },
      {
        title: 'چه زمانی نیاز به بررسی دارد؟',
        style: 'bullet',
        items: [
          'وقتی شاخص در چند ماه متوالی روند نزولی داشته باشد.',
          'وقتی شاخص منفی شود.',
        ],
      },
      {
        title: 'نکته تحلیلی: یک عدد مثبت همیشه به یک اندازه خوب نیست',
        style: 'none',
        items: [
          'خط زرد فقط حاصل جمع نهایی است، اما ترکیب داخلی‌اش می‌تواند دو داستان کاملاً متفاوت را روایت کند که هر دو در ظاهر «رشد مثبت» به نظر می‌رسند:',
        ],
      },
      {
        title: 'دو سناریوی رشد مثبت',
        style: 'bullet',
        items: [
          'اگر رشد مثبت باشد و عمدتاً به‌خاطر حجم بالای مشتریان جدید باشد، در حالی‌که ستون «مشتریان غیرفعال» هم بزرگ و رو به افزایش است: رستوران دائم مشتری تازه جذب می‌کند تا جای مشتریانی را که همان ماه رسماً از دست داده، پر کند. این نوع رشد پرهزینه‌تر است، چون جذب مشتری تازه معمولاً گران‌تر از حفظ مشتری قدیمی تمام می‌شود، و اگر روزی نرخ جذب کند شود، همان ریزش پنهان‌شده زیر رشد ظاهری می‌شود.',
          'اگر رشد مثبت باشد و عمدتاً به‌خاطر حجم بالای مشتریان قدیمیِ بازگشته باشد: این رشد سالم‌تر و کم‌هزینه‌تر است، چون نشان می‌دهد رستوران در نگهداشت و بازگرداندن مشتریانی که قبلاً به آن‌ها دسترسی داشته، موفق عمل کرده است.',
        ],
      },
    ],
  },

  // Executive Dashboard Charts
  creditUsageRate: {
    title: 'راهنمای نرخ مصرف اعتبار',
    description: 'این نمودار شعاعی، درصد استفاده از اعتبارات تخصیصی را نشان می‌دهد.',
    interpretation: 'نرخ بالا نشان‌دهنده استفاده مؤثر از منابع است. نرخ پایین ممکن است نشان‌دهنده عدم استفاده بهینه باشد.',
    tips: [
      'دلایل عدم استفاده کامل از اعتبارات را بررسی کنید',
      'برنامه‌ریزی برای استفاده بهینه از اعتبارات داشته باشید',
      'روند ماهیانه را برای شناسایی الگوها پیگیری کنید'
    ]
  },

  keyIndicatorsTrend: {
    title: 'راهنمای روند شاخص‌های کلیدی',
    description: 'این نمودار روند تغییرات شاخص‌های کلیدی عملکرد (KPI) را نمایش می‌دهد.',
    interpretation: 'هر خط نماینده یک شاخص است. روند صعودی در اکثر شاخص‌ها مطلوب است.',
    tips: [
      'شاخص‌هایی که از هدف عقب هستند را اولویت‌بندی کنید',
      'همبستگی بین شاخص‌های مختلف را بررسی کنید',
      'برای هر شاخص اهداف واقع‌بینانه تعیین کنید'
    ]
  },

  creditProductionConsumption: {
    title: 'راهنمای مقایسه تولید و مصرف اعتبار',
    description: 'این نمودار میله‌ای، تعداد اعتبار تولیدی به تعداد سفارش و مصرف شده را مقایسه می‌کند.',
    interpretation: 'تعادل بین تولید و مصرف اعتبار نشان‌دهنده مدیریت مالی سالم است.',
    tips: [
      'اگر مصرف بیشتر از تولید است، استراتژی‌های افزایش درآمد را بررسی کنید',
      'اعتبار استفاده نشده را برای فرصت‌های رشد سرمایه‌گذاری کنید',
      'روند بلندمدت را برای برنامه‌ریزی مالی استفاده کنید'
    ]
  },

  // Heatmap and Performance
  performanceHeatmap: {
    title: 'راهنمای نقشه حرارتی عملکرد',
    description: 'این نقشه حرارتی، عملکرد شعب مختلف را با استفاده از رنگ‌بندی نمایش می‌دهد.',
    interpretation: 'رنگ‌های سبز نشان‌دهنده عملکرد خوب، زرد متوسط و قرمز نیازمند بهبود است.',
    tips: [
      'الگوهای مشترک در شعب موفق را شناسایی کنید',
      'شعب قرمز را برای حمایت و بهبود اولویت‌بندی کنید',
      'بهترین شیوه‌ها را از شعب سبز به سایرین منتقل کنید'
    ]
  },

  branchComparison: {
    title: 'راهنمای مقایسه عملکرد شعب',
    description: 'این نمودار عملکرد شعبه شما را با گروه برند و بازار مقایسه می‌کند.',
    interpretation: 'موقعیت شعبه نسبت به میانگین‌ها نشان‌دهنده جایگاه رقابتی شما است.',
    tips: [
      'اگر زیر میانگین هستید، دلایل و راه‌حل‌ها را بررسی کنید',
      'از شعب برتر الگوبرداری کنید',
      'اهداف واقع‌بینانه برای رسیدن به میانگین یا فراتر از آن تعیین کنید'
    ]
  },

  // HR Dashboard Charts
  rolePerformanceComparison: {
    title: 'راهنمای مقایسه رضایت بر اساس نقش',
    description: 'این نمودار میله‌ای، میانگین رضایت مشتریان را برای هر نقش شغلی (صندوقدار، پیک، میزبان) نمایش می‌دهد.',
    interpretation: 'میله‌های بلندتر نشان‌دهنده رضایت بیشتر مشتریان از آن نقش است. تفاوت‌های چشمگیر بین نقش‌ها نیاز به بررسی دارد.',
    tips: [
      'نقش‌هایی با رضایت پایین را برای آموزش اولویت‌بندی کنید',
      'بهترین شیوه‌ها را از نقش‌های موفق به سایر نقش‌ها منتقل کنید',
      'استانداردهای عملکرد برای هر نقش تعریف کنید'
    ]
  },

  topPerformersChart: {
    title: 'راهنمای نمودار برترین عملکردها',
    description: 'این نمودار شش پرسنل برتر را بر اساس رضایت مشتریان و نظرات مثبت نمایش می‌دهد.',
    interpretation: 'پرسنل در ابتدای لیست بهترین عملکرد را دارند. مقایسه رضایت و نظرات مثبت کیفیت کلی خدمات را نشان می‌دهد.',
    tips: [
      'از پرسنل برتر برای آموزش سایرین استفاده کنید',
      'دلایل موفقیت پرسنل برتر را شناسایی و مستندسازی کنید',
      'سیستم پاداش برای تشویق عملکرد برتر طراحی کنید'
    ]
  },

  // Evaluation Report Charts
  evaluationScoresTrend: {
    title: 'راهنمای روند نمرات ارزیابی',
    description: 'این نمودار روند تغییرات نمرات ارزیابی مختلف را در طول زمان نشان می‌دهد.',
    interpretation: 'خطوط صعودی نشان‌دهنده بهبود و خطوط نزولی نیاز به توجه دارند. ثبات در نمرات بالا مطلوب است.',
    tips: [
      'معیارهایی که روند نزولی دارند را اولویت‌بندی کنید',
      'از بهبودهای موفق برای تکرار در سایر حوزه‌ها استفاده کنید',
      'اهداف کوتاه‌مدت برای بهبود نمرات پایین تعیین کنید'
    ]
  },

  evaluationMonthlyPerformanceTable: {
    title: 'راهنمای جدول «عملکرد ماهانه ارزیابی»',
    description: 'این جدول همه شاخص‌های مربوط به نظرسنجی رضایت مشتری و زیرساخت ارسال پیامک را در کنار هم نمایش می‌دهد، تا بشود در یک نگاه هم کیفیت رضایت مشتری و هم سلامت فرآیند جمع‌آوری نظرات را بررسی کرد.',
    interpretation: '',
    sections: [
      {
        title: 'تعریف ستون‌ها',
        style: 'decimal',
        items: [
          'اشتراک‌گیری: درصد سفارشاتی که شماره تماس مشتری برایشان ثبت شده است.',
          'تعداد سفارش: تعداد کل سفارشات ثبت‌شده در آن ماه.',
          'مشارکت در نظرسنجی: چه سهمی از پیامک‌های نظرسنجی ارسال‌شده، پاسخ داده شده‌اند. فرمول: مجموع نظرات ÷ پیامک‌های نظرسنجی ارسالی.',
          'درصد نظرات مثبت: از میان همه نظرات ثبت‌شده، چه درصدی «خوب» یا «عالی» بوده‌اند. فرمول: نظرات راضی ÷ مجموع نظرات.',
          'نظرات راضی: تعداد نظراتی که فقط گزینه «خوب» یا «عالی» انتخاب کرده‌اند.',
          'نظرات ناراضی: تعداد نظراتی که در حداقل یکی از سؤالات، «متوسط» یا «ضعیف» انتخاب کرده‌اند.',
          'مجموع نظرات: تعداد کل نظراتی که در آن ماه ثبت شده است.',
          'پیامک‌های ارسالی: تعداد پیامک‌های نظرسنجی که در آن ماه برای مشتریان ارسال شده است.',
          'روزهای بدون شارژ پیامک: تعداد روزهایی در آن ماه که شارژ پیامک تمام شده و ارسال پیامک متوقف بوده است.',
        ],
      },
      {
        title: 'نکته کاربردی',
        style: 'none',
        items: [
          'بهترین راه خواندن این جدول، دیدن ستون‌ها در کنار هم است، نه تک‌تک:',
        ],
      },
      {
        title: 'خواندن ترکیبی ستون‌ها',
        style: 'bullet',
        items: [
          '«مجموع نظرات» باید همیشه با حداقل ۷۰ نظر در ماه مقایسه شود؛ اگر مجموع نظرات یک ماه کمتر از ۷۰ باشد، عدد «درصد نظرات مثبت» همان ماه را نباید به‌تنهایی و با اطمینان تفسیر کرد.',
          'افت هم‌زمان در «پیامک‌های ارسالی» و «مجموع نظرات»، در کنار عدد بالا در «روزهای بدون شارژ پیامک»، نشان می‌دهد افت نظرات به‌خاطر قطع ارسال پیامک بوده، نه تغییر واقعی در رفتار یا رضایت مشتری.',
          '«مشارکت در نظرسنجی» پایین یا رو به کاهش، جدا از میزان رضایت، خودش یک هشدار است؛ چون هرچه این نرخ پایین‌تر باشد، نظرات ثبت‌شده نماینده ضعیف‌تری از کل مشتریان آن ماه هستند و ممکن است بیشتر از مشتریان خیلی راضی یا خیلی ناراضی (نه مشتریان معمولی) جمع شده باشند.',
          'اشتراک‌گیری پایین هم روی همین جدول اثر می‌گذارد؛ چون بدون شماره تماس مشتری، اصلاً امکان ارسال پیامک نظرسنجی برای آن سفارش وجود ندارد.',
        ],
      },
    ],
  },

  evaluationRadarChart: {
    title: 'راهنمای نمودار راداری ارزیابی',
    description: 'این نمودار راداری امتیازات شعبه را در معیارهای مختلف به صورت یکپارچه نمایش می‌دهد.',
    interpretation: 'شکل متعادل و نزدیک به دایره کامل نشان‌دهنده عملکرد متوازن است. فرورفتگی‌ها نقاط ضعف را نشان می‌دهند.',
    tips: [
      'به دنبال ایجاد تعادل در همه معیارها باشید',
      'نقاط ضعف (فرورفتگی‌ها) را برای بهبود اولویت‌بندی کنید',
      'نقاط قوت خود را حفظ کرده و بر آن‌ها تکیه کنید'
    ]
  },

  // Customer Club Heatmap Charts
  customerActivityHeatmap: {
    title: 'راهنمای نقشه حرارتی فعالیت مشتریان',
    description: 'این نقشه حرارتی، میزان فعالیت مشتریان را در روزها و ساعات مختلف نمایش می‌دهد.',
    interpretation: 'رنگ‌های قرمز‌تر نشان‌دهنده فعالیت بیشتر و رنگ‌های آبی‌تر فعالیت کمتر است.',
    tips: [
      'ساعات و روزهای پرترافیک را شناسایی و منابع را متناسب تخصیص دهید',
      'برای ساعات کم‌ترافیک برنامه‌های تشویقی طراحی کنید',
      'الگوهای هفتگی و ماهانه را برای برنامه‌ریزی بهتر شناسایی کنید'
    ]
  },

  customerSegmentAnalysis: {
    title: 'راهنمای تحلیل بخش‌بندی مشتریان',
    description: 'این نمودار مشتریان را بر اساس میزان خرید و فعالیت به بخش‌های مختلف تقسیم می‌کند.',
    interpretation: 'هر بخش نیازها و رفتارهای متفاوتی دارد. بخش‌های با ارزش بالا نیاز به توجه ویژه دارند.',
    tips: [
      'برای هر بخش استراتژی بازاریابی جداگانه تدوین کنید',
      'مشتریان را از بخش‌های پایین‌تر به بالاتر هدایت کنید',
      'برنامه‌های وفاداری متناسب با هر بخش طراحی کنید'
    ]
  },

  clubMembershipTrend: {
    title: 'راهنمای روند عضویت باشگاه مشتریان',
    description: 'این نمودار روند رشد تعداد اعضای باشگاه مشتریان را نمایش می‌دهد.',
    interpretation: 'روند صعودی پایدار نشان‌دهنده جذابیت برنامه باشگاه است. رکود یا کاهش نیاز به بازنگری دارد.',
    tips: [
      'مزایای باشگاه را برای افزایش جذب عضو بهبود دهید',
      'نرخ ریزش اعضا را محاسبه و دلایل آن را بررسی کنید',
      'کمپین‌های عضوگیری در زمان‌های استراتژیک برگزار کنید'
    ]
  },
  
  // Refine Customer Dashboard Charts
  'survey-responses-type': {
    title: 'تحلیل پاسخ‌های نظرسنجی بر اساس نوع',
    description: 'این نمودار توزیع پاسخ‌های مشتریان را در سه دسته مثبت، منفی و خنثی نمایش می‌دهد. پاسخ‌های مثبت نشان‌دهنده رضایت، منفی نشان‌دهنده نارضایتی و خنثی نشان‌دهنده بی‌تفاوتی مشتریان است.',
    interpretation: 'درصد بالای پاسخ‌های مثبت (بالای 60%) نشان‌دهنده عملکرد مطلوب است. پاسخ‌های منفی بالای 30% نیاز به بررسی فوری دارد.',
    tips: [
      'دلایل پاسخ‌های منفی را تحلیل کنید',
      'از مشتریان با پاسخ خنثی بازخورد بیشتر بگیرید',
      'اقدامات اصلاحی را بر اساس نتایج اولویت‌بندی کنید'
    ]
  },

  'survey-responses-by-answer': {
    title: 'راهنمای نمودار «تعداد سؤالات پاسخ‌داده‌شده به تفکیک نظر»',
    description: 'این نمودار تعداد کل پاسخ‌هایی که مشتریان به سؤالات نظرسنجی داده‌اند را بر اساس نوع پاسخ (عالی، خوب، متوسط، ضعیف) نشان می‌دهد. برخلاف شاخص رضایت کلی که هر نظر (پاسخ یک مشتری به کل نظرسنجی) را یک واحد حساب می‌کند، این نمودار تک‌تک پاسخ‌ها به سؤالات را می‌شمارد؛ یعنی اگر یک نظرسنجی چند سؤال داشته باشد و یک مشتری به هرکدام جواب بدهد، همه آن پاسخ‌ها جداگانه در دسته مربوط به خودشان شمرده می‌شوند.',
    interpretation: '',
  },
  
  'complaint-status': {
    title: 'راهنمای نمودار «وضعیت بررسی شکایات»',
    description: 'هر نظری که در آن حتی یک پاسخ «متوسط» یا «ضعیف» ثبت شده باشد، یک «شکایت» محسوب می‌شود. این نمودار نشان می‌دهد از میان همه این شکایات، چه تعدادشان توسط رستوران بررسی شده و چه تعدادشان هنوز بررسی نشده باقی مانده‌اند.',
    interpretation: '',
    sections: [
      {
        title: 'نکته کاربردی',
        style: 'none',
        items: [
          'اگر سهم «بررسی‌نشده» بالا یا رو به افزایش باشد، یعنی شکایات مشتریان با تأخیر یا بدون پیگیری می‌مانند، که خودش می‌تواند باعث از دست رفتن همان مشتری ناراضی شود، حتی اگر علت اصلی شکایتش قبلاً برطرف شده باشد.',
        ],
      },
    ],
  },
  
  'dissatisfaction-reasons': {
    title: 'راهنمای نمودار «دلایل نارضایتی»',
    description: 'این نمودار سؤالاتی که روی آن‌ها دلیل نارضایتی ثبت شده است را از بیشترین به کمترین نمایش می‌دهد. با کلیک روی هر ستون، جزئیات همان سؤال باز می‌شود: جدولی که دلیل‌های دقیق نارضایتی برای آن سؤال را، به‌همراه تعداد و درصد هرکدام، فهرست می‌کند.',
    interpretation: '',
    sections: [
      {
        title: 'نکته کاربردی',
        style: 'none',
        items: [
          'این نمودار عمیق‌ترین سطح ریشه‌یابی نارضایتی در کل داشبورد است: ابتدا مشخص می‌کند کدام سؤال بیشترین نارضایتی را دارد، و سپس با باز کردن جزئیات، دقیقاً کدام دلیل مشخص (نه فقط یک سؤال کلی) عامل اصلی آن است. برای اقدام اصلاحی مؤثر، بهتر است ابتدا سراغ اولین ستون (بیشترین تعداد دلیل ثبت‌شده) رفت و در جزئیاتش، دلیلی که بالاترین درصد را دارد، در اولویت رفع قرار داد.',
        ],
      },
    ],
  },

  // Additional Executive Dashboard Charts
  trendAnalysisChart: {
    title: 'راهنمای نمودار تحلیل روند',
    description: 'این نمودار روند شاخص‌های کلیدی عملکرد مدیریتی را در طول زمان نمایش می‌دهد.',
    interpretation: 'روند صعودی در شاخص‌های کلیدی نشان‌دهنده رشد و بهبود عملکرد است. نوسانات شدید نیاز به بررسی دارد.',
    tips: [
      'روند بلندمدت را از نوسانات کوتاه‌مدت تفکیک کنید',
      'شاخص‌های همبسته را با هم تحلیل کنید',
      'نقاط عطف را شناسایی و علل آن‌ها را بررسی کنید'
    ]
  },

  creditComparisonChart: {
    title: 'راهنمای نمودار مقایسه اعتبار',
    description: 'این نمودار میزان اعتبار تولیدی، مصرفی و باقی‌مانده را مقایسه می‌کند.',
    interpretation: 'تعادل مناسب بین تولید و مصرف اعتبار نشان‌دهنده مدیریت مالی کارآمد است.',
    tips: [
      'نسبت مصرف به تولید را در محدوده بهینه نگه دارید',
      'اعتبار باقی‌مانده را برای فرصت‌های رشد برنامه‌ریزی کنید',
      'روند ماهیانه را برای پیش‌بینی نیازهای آینده تحلیل کنید'
    ]
  },

  executivePerformanceTable: {
    title: 'راهنمای جدول عملکرد مدیریتی',
    description: 'این جدول شاخص‌های کلیدی عملکرد مدیریتی را به صورت دوره‌ای نمایش می‌دهد.',
    interpretation: 'مقایسه عملکرد دوره‌های مختلف به شناسایی روندها و الگوها کمک می‌کند.',
    tips: [
      'شاخص‌های زیر هدف را اولویت‌بندی کنید',
      'از داده‌های جدول برای تعیین اهداف واقع‌بینانه استفاده کنید',
      'عملکرد را با دوره‌های مشابه سال قبل مقایسه کنید'
    ]
  },

  // Customer Analytics Charts
  purchasePercentagesChart: {
    title: 'راهنمای نمودار درصد خرید',
    description: 'این نمودار درصد مشتریانی که در دوره‌های مختلف خرید داشته‌اند را نمایش می‌دهد.',
    interpretation: 'درصد بالاتر نشان‌دهنده تعامل بیشتر مشتریان با رستوران است.',
    tips: [
      'روند کاهشی را به عنوان هشدار جدی بگیرید',
      'برنامه‌های تشویقی برای افزایش درصد خرید طراحی کنید',
      'دلایل عدم خرید مشتریان را بررسی کنید'
    ]
  },

  totalOrdersNonOrders: {
    title: 'راهنمای مقایسه سفارش‌دهندگان و غیرسفارش‌دهندگان',
    description: 'این نمودار نسبت مشتریانی که سفارش داده‌اند به کل مشتریان را نشان می‌دهد.',
    interpretation: 'نسبت بالاتر سفارش‌دهندگان نشان‌دهنده جذابیت بیشتر منو و خدمات است.',
    tips: [
      'دلایل عدم سفارش را از مشتریان جویا شوید',
      'منو و قیمت‌ها را برای جذابیت بیشتر بهینه کنید',
      'پیشنهادات ویژه برای تبدیل غیرسفارش‌دهندگان ارائه دهید'
    ]
  },

  totalCustomerOrders: {
    title: 'راهنمای کل سفارشات مشتریان',
    description: 'این نمودار تعداد کل سفارشات و توزیع آن‌ها را نمایش می‌دهد.',
    interpretation: 'روند افزایشی سفارشات نشان‌دهنده رشد کسب‌وکار است.',
    tips: [
      'میانگین سفارش هر مشتری را محاسبه و افزایش دهید',
      'ساعات اوج سفارش را شناسایی و مدیریت کنید',
      'کیفیت خدمات را در زمان‌های پرسفارش حفظ کنید'
    ]
  },

  ordersLastTwoMonths: {
    title: 'راهنمای سفارشات دو ماه اخیر',
    description: 'این نمودار عملکرد سفارشات در دو ماه گذشته را نمایش می‌دهد.',
    interpretation: 'مقایسه دو ماه اخیر به شناسایی روندهای کوتاه‌مدت کمک می‌کند.',
    tips: [
      'تغییرات قابل توجه را با رویدادهای خاص مطابقت دهید',
      'از داده‌ها برای پیش‌بینی ماه آینده استفاده کنید',
      'استراتژی‌های موفق ماه قبل را تکرار کنید'
    ]
  },

  customerTrendsChart: {
    title: 'راهنمای نمودار روندهای مشتری',
    description: 'این نمودار روند تغییرات رفتار و تعداد مشتریان را نشان می‌دهد.',
    interpretation: 'شناسایی روندها به پیش‌بینی و برنامه‌ریزی بهتر کمک می‌کند.',
    tips: [
      'روندهای فصلی را شناسایی و برای آن‌ها آماده شوید',
      'تأثیر کمپین‌های بازاریابی را بر روندها بررسی کنید',
      'از روندهای مثبت برای برنامه‌ریزی رشد استفاده کنید'
    ]
  },

  customerBalanceChart: {
    title: 'راهنمای نمودار رشد مشتریان',
    description: 'این نمودار وضعیت مالی و اعتباری مشتریان را نمایش می‌دهد.',
    interpretation: 'تراز مثبت نشان‌دهنده اعتبار موجود و منفی نشان‌دهنده بدهی است.',
    tips: [
      'مشتریان با اعتبار بالا را برای برنامه‌های ویژه هدف قرار دهید',
      'برای وصول بدهی‌ها برنامه‌ریزی کنید',
      'سیستم اعتباری را برای تشویق خرید بیشتر بهینه کنید'
    ]
  },

  customerTrendsWithBalanceChart: {
    title: 'راهنمای نمودار «تحلیل حفظ مشتریان»',
    description: 'این نمودار نشان می‌دهد به‌طور کلی در هر ماه، رستوران در حال جذب خالص مشتری است یا در حال از دست دادن آن‌ها. سه ستون هر ماه (مشتریان قدیمی، مشتریان جدید، مشتریان غیرفعال) اجزای این تصویرند، و خط زرد روی نمودار، خلاصه نهایی و حاصل جمع این اجزا در قالب یک عدد واحد به نام «رشد مشتریان» است.',
    interpretation: 'مشتریان جدید: کسانی که برای اولین بار در آن ماه از رستوران خرید کرده‌اند. مشتریان قدیمی: مشتریانی که سابقه خرید قبلی داشته‌اند و در همان ماه هم دوباره خرید کرده‌اند؛ یعنی مشتریانی که رستوران توانسته آن‌ها را حفظ کند. مشتریان غیرفعال: مشتریانی که دقیقاً در همان ماه، یک سال کامل از آخرین خریدشان می‌گذرد و در این یک سال هیچ خرید دیگری ثبت نکرده‌اند؛ یعنی کسانی که در همین ماه، رسماً وارد وضعیت «غیرفعال» شده‌اند. فرمول رشد مشتریان: رشد مشتریان = کل مشتریان ماه − مشتریان از دست‌رفته همان ماه. مشتری جدید و بازگشت مشتری قدیمی به رشد این نمودار کمک می‌کند؛ رسیدن مشتریان قدیمی به آستانه یک سال بدون خرید (تبدیل شدنشان به مشتری غیرفعال) باعث افت این نمودار می‌شود.',
    sections: [
      {
        title: 'چرا این نمودار مهم است؟',
        style: 'none',
        items: [
          'این نمودار در یک نگاه، اثر خالص سه نیروی متضاد را روی هم نشان می‌دهد: جذب (مشتری جدید)، بازگشت (مشتری قدیمی که دوباره خرید کرده) و ریزش (مشتری قدیمی که از دست رفته). به‌جای اینکه این سه عدد را جدا جدا و پراکنده در جاهای مختلف دنبال کنید، خط زرد یک جمع‌بندی واحد از سلامت کلی رابطه رستوران با مشتریانش ارائه می‌دهد.',
        ],
      },
      {
        title: 'چگونه خوانده شود؟',
        style: 'bullet',
        items: [
          'مثبت: تعداد مشتریانی که به چرخه خرید اضافه یا از میان مشتریان از دست‌رفته بازگردانده شده‌اند، بیشتر از تعداد مشتریانی است که از دست رفته‌اند.',
          'نزدیک به صفر: جذب و نگهداشت مشتری، با ریزش مشتری در یک تعادل ناپایدار قرار گرفته؛ رستوران دارد دقیقاً به همان اندازه‌ای که مشتری از دست می‌دهد، مشتری جایگزین می‌کند، بدون رشد واقعی.',
          'منفی: سرعت از دست دادن مشتری، از سرعت بازگشت و جذب مشتری بیشتر بوده است. این حالت می‌تواند به دلایلی مانند افزایش قیمت، نارضایتی مشتری، افت کیفیت غذا یا خدمات، یا ورود رقبای تازه به بازار باشد.',
        ],
      },
      {
        title: 'چه زمانی نیاز به بررسی دارد؟',
        style: 'bullet',
        items: [
          'وقتی شاخص در چند ماه متوالی روند نزولی داشته باشد.',
          'وقتی شاخص منفی شود.',
        ],
      },
      {
        title: 'نکته تحلیلی: یک عدد مثبت همیشه به یک اندازه خوب نیست',
        style: 'none',
        items: [
          'خط زرد فقط حاصل جمع نهایی است، اما ترکیب داخلی‌اش می‌تواند دو داستان کاملاً متفاوت را روایت کند که هر دو در ظاهر «رشد مثبت» به نظر می‌رسند:',
        ],
      },
      {
        title: 'دو سناریوی رشد مثبت',
        style: 'bullet',
        items: [
          'اگر رشد مثبت باشد و عمدتاً به‌خاطر حجم بالای مشتریان جدید باشد، در حالی‌که ستون «مشتریان غیرفعال» هم بزرگ و رو به افزایش است: رستوران دائم مشتری تازه جذب می‌کند تا جای مشتریانی را که همان ماه رسماً از دست داده، پر کند. این نوع رشد پرهزینه‌تر است، چون جذب مشتری تازه معمولاً گران‌تر از حفظ مشتری قدیمی تمام می‌شود، و اگر روزی نرخ جذب کند شود، همان ریزش پنهان‌شده زیر رشد ظاهری می‌شود.',
          'اگر رشد مثبت باشد و عمدتاً به‌خاطر حجم بالای مشتریان قدیمیِ بازگشته باشد: این رشد سالم‌تر و کم‌هزینه‌تر است، چون نشان می‌دهد رستوران در نگهداشت و بازگرداندن مشتریانی که قبلاً به آن‌ها دسترسی داشته، موفق عمل کرده است.',
        ],
      },
    ],
  },

  noOrdersLastTwoMonths: {
    title: 'راهنمای مشتریان بدون سفارش در دو ماه اخیر',
    description: 'این نمودار مشتریانی که در دو ماه گذشته سفارشی نداشته‌اند را نمایش می‌دهد.',
    interpretation: 'تعداد بالا نشان‌دهنده ریزش مشتری و نیاز به اقدام فوری است.',
    tips: [
      'کمپین بازگشت مشتری برای این گروه طراحی کنید',
      'دلایل عدم بازگشت را بررسی کنید',
      'پیشنهادات ویژه برای تشویق بازگشت ارائه دهید'
    ]
  },

  customerReport: {
    title: 'راهنمای گزارش جامع مشتریان',
    description: 'این گزارش وضعیت کلی مشتریان و تعاملات آن‌ها را نمایش می‌دهد.',
    interpretation: 'تحلیل جامع داده‌ها به درک بهتر نیازها و رفتار مشتریان کمک می‌کند.',
    tips: [
      'از داده‌ها برای بخش‌بندی مشتریان استفاده کنید',
      'استراتژی‌های متناسب با هر بخش طراحی کنید',
      'عملکرد را با اهداف تعیین شده مقایسه کنید'
    ]
  },

  averagePurchasesTable: {
    title: 'راهنمای جدول «میانگین خرید مشتریان»',
    description: 'این جدول تعداد مشتریان، تعداد سفارشات همان مشتریان و میانگین تکرار خرید هر مشتری را به‌صورت ماهانه نمایش می‌دهد. نحوه محاسبه میانگین خرید: تعداد سفارشات آن ماه تقسیم بر تعداد مشتریان همان ماه.',
    interpretation: 'این گزارش نشان می‌دهد مشتریان فقط یک‌بار به رستوران سر می‌زنند یا واقعاً به مشتری تکراری تبدیل می‌شوند. رستورانی که مشتری زیادی جذب می‌کند ولی هر مشتری فقط یک‌بار خرید می‌کند، در واقع در وفادارسازی ضعیف عمل کرده، حتی اگر ظاهراً تعداد مشتریانش رو به رشد باشد.',
    sections: [
      {
        title: 'چگونه خوانده شود؟',
        style: 'bullet',
        items: [
          'افزایش میانگین خرید نشان می‌دهد بازگشت مشتریان بیشتر شده است؛ این می‌تواند به معنای رضایت بیشتر مشتری، تناسب بهتر محصول و خدمات با نیاز او، یا اثربخشی برنامه‌های نگهداشت مشتری باشد.',
          'کاهش میانگین خرید می‌تواند دو دلیل مجزا داشته باشد که باید از هم تفکیک شوند: ورود حجم زیادی مشتری جدید که هنوز فرصت خرید مجدد نداشته‌اند (این حالت لزوماً نگران‌کننده نیست، چون نشانه رشد پایگاه مشتری است).',
          'کاهش واقعی تعداد دفعات خرید مشتریان بازگشتی (این حالت هشدار جدی است، چون یعنی مشتریان قدیمی‌تر هم کند شده‌اند).',
        ],
      },
      {
        title: 'چه زمانی نیاز به بررسی دارد؟',
        style: 'bullet',
        items: [
          'وقتی میانگین خرید روند باثبات یا رو به رشدی نداشته باشد؛ یعنی نوسان بی‌دلیل یا روند نزولی پیوسته در چند ماه متوالی مشاهده شود.',
        ],
      },
      {
        title: 'اقدام پیشنهادی',
        style: 'bullet',
        items: [
          'ارائه هدیه برای خرید بعدی',
          'ترغیب مشتری جدید به تکرار خرید، از طریق کمپین‌های وفاداری (ایونت)',
          'بررسی تجربه سفارش (کیفیت غذا، سرعت سرویس، تجربه پرداخت) برای یافتن علت افت بازگشت مشتری',
        ],
      },
      {
        title: 'نکته: تفاوت دو جدول کنار هم (دو دوربین، دو زاویه دید)',
        style: 'none',
        items: [
          'این گزارش را می‌توان به دو دوربین با فاصله کانونی متفاوت تشبیه کرد؛ یکی «عکس لحظه‌ای» می‌گیرد و دیگری «فیلم بلندمدت» ضبط می‌کند:',
          'میانگین خرید مشتریان (نسبت به ماه قبل): این عکس لحظه‌ای است؛ فقط مشتریانی را می‌بیند که در همان ماه مشخص خرید کرده‌اند و میانگین خرید همان‌ها را در همان بازه یک‌ماهه می‌سنجد. حساس و زودهنگام است: هر تکانی در رفتار مشتری، همان ماه در این عدد خودش را نشان می‌دهد.',
          'میانگین خرید مشتریان در ماه (تعداد کل مشتریان): این یک پنجره متحرک ۱۲ ماهه است، نه یک عدد تجمعی از ابتدای فعالیت رستوران. یعنی میانگین خرید اردیبهشت، از تعداد خرید و تعداد مشتریان بازه «خرداد سال قبل تا اردیبهشت امسال» به دست می‌آید و هر ماه، یک ماه از عقب کنار گذاشته و یک ماه جدید به جلو اضافه می‌شود؛ درست مثل نواری که هر بار یک قاب از عقب بیرون می‌رود و یک قاب تازه از جلو وارد می‌شود.',
        ],
      },
      {
        title: 'مزیت هر کدام',
        style: 'bullet',
        items: [
          'عکس لحظه‌ای (ماهانه) سریع‌تر واکنش نشان می‌دهد؛ اگر مشکلی در یک ماه خاص پیش بیاید (مثلاً افت کیفیت غذا یا مشکل سرویس)، بلافاصله در همین جدول دیده می‌شود. مزیتش هشدار زودهنگام است، اما همین حساسیت باعث می‌شود نوسانات فصلی یا اتفاقات موقت (مثل تعطیلات یا رویداد خاص شهر) هم به‌اشتباه به چشم بیاید.',
          'پنجره متحرک ۱۲ ماهه نویز و نوسانات فصلی را صاف می‌کند و تصویری پایدارتر و قابل‌اعتمادتر از روند واقعی وفاداری ارائه می‌دهد؛ چون هر ماه، اثر ماه‌های اوج و افت فصلی سال قبل را هم در خودش دارد. مزیتش دقت و ثبات است، اما همین ویژگی باعث می‌شود واکنشش به یک اتفاق تازه، کند و با تأخیر چند ماهه ظاهر شود؛ یعنی وقتی مشکلی در پنجره ۱۲ ماهه دیده شود، احتمالاً چند ماه از شروع واقعی آن گذشته است.',
        ],
      },
      {
        title: 'کدام را باید بیشتر در نظر گرفت؟',
        style: 'none',
        items: [
          'برای تصمیم‌گیری روزمره و واکنش سریع (مثلاً «همین ماه چه اتفاقی افتاده؟»)، باید به جدول ماهانه اول تکیه کرد. اما برای قضاوت درباره سلامت کلی و روند واقعی کسب‌وکار (مثلاً «آیا در یک‌سال گذشته واقعاً وفاداری مشتری بهتر شده؟»)، پنجره متحرک ۱۲ ماهه معیار قابل‌اعتمادتری است، چون نوسانات لحظه‌ای و فصلی را خنثی می‌کند. بهترین رویکرد، خواندن هر دو در کنار هم است: جدول ماهانه به‌عنوان «زنگ هشدار زودهنگام» و پنجره ۱۲ ماهه به‌عنوان «داور نهایی» که تأیید می‌کند آن هشدار، یک روند واقعی بوده یا فقط یک نوسان موقتی.',
        ],
      },
      {
        title: 'نکته تحلیلی: مقایسه رشد میانگین خرید با رشد تعداد مشتریان',
        style: 'none',
        items: [
          'مهم‌ترین تحلیل این جدول از مقایسه ستون «رشد نسبت به ماه قبل» در میانگین خرید، با رشد هم‌زمان تعداد مشتریان به دست می‌آید:',
        ],
      },
      {
        title: 'سناریوهای مقایسه',
        style: 'bullet',
        items: [
          'اگر تعداد مشتریان و میانگین خرید هر دو هم‌زمان رشد کنند: بهترین حالت ممکن است؛ رستوران هم مشتری جدید جذب می‌کند و هم مشتریان قدیمی را حفظ و فعال‌تر نگه می‌دارد.',
          'اگر تعداد مشتریان رشد کند ولی میانگین خرید افت کند: رشد مشتری صرفاً کمی است، نه کیفی؛ رستوران در جذب مشتری موفق بوده اما در نگهداشت او ضعیف عمل کرده و باید روی تجربه مشتری و برنامه‌های بازگشت سرمایه‌گذاری کند.',
          'اگر تعداد مشتریان ثابت یا نزولی باشد ولی میانگین خرید رشد کند: رستوران مشتری تازه کمتری جذب می‌کند، اما مشتریان موجود وفادارتر شده‌اند؛ نشانه‌ای برای تمرکز بیشتر روی جذب مشتری جدید در کنار حفظ کیفیت فعلی.',
        ],
      },
    ],
  },

  averagePurchasesYoYTable: {
    title: 'راهنمای جدول «میانگین خرید مشتریان در ماه» (پنجره ۱۲ ماهه)',
    description: 'میانگین خرید مشتریان در ماه (تعداد کل مشتریان): پنجره متحرک ۱۲ ماهه — هر ماه یک ماه از عقب کنار گذاشته و یک ماه جدید به جلو اضافه می‌شود. این جدول در کنار جدول میانگین خرید ماهانه (عکس لحظه‌ای همان ماه) قرار دارد.',
    interpretation: 'برای قضاوت درباره سلامت کلی و روند واقعی کسب‌وکار (مثلاً «آیا در یک‌سال گذشته واقعاً وفاداری مشتری بهتر شده؟»)، پنجره متحرک ۱۲ ماهه معیار قابل‌اعتمادتری است، چون نوسانات لحظه‌ای و فصلی را خنثی می‌کند. بهترین رویکرد، خواندن هر دو در کنار هم است: جدول ماهانه به‌عنوان «زنگ هشدار زودهنگام» و پنجره ۱۲ ماهه به‌عنوان «داور نهایی».',
    sections: [
      {
        title: 'مزیت پنجره ۱۲ ماهه',
        style: 'none',
        items: [
          'پنجره متحرک ۱۲ ماهه نویز و نوسانات فصلی را صاف می‌کند و تصویری پایدارتر و قابل‌اعتمادتر از روند واقعی وفاداری ارائه می‌دهد؛ چون هر ماه، اثر ماه‌های اوج و افت فصلی سال قبل را هم در خودش دارد. مزیتش دقت و ثبات است، اما همین ویژگی باعث می‌شود واکنشش به یک اتفاق تازه، کند و با تأخیر چند ماهه ظاهر شود؛ یعنی وقتی مشکلی در پنجره ۱۲ ماهه دیده شود، احتمالاً چند ماه از شروع واقعی آن گذشته است.',
        ],
      },
      {
        title: 'نکته تحلیلی: مقایسه رشد میانگین خرید با رشد تعداد مشتریان',
        style: 'bullet',
        items: [
          'اگر تعداد مشتریان و میانگین خرید هر دو هم‌زمان رشد کنند: بهترین حالت ممکن است؛ رستوران هم مشتری جدید جذب می‌کند و هم مشتریان قدیمی را حفظ و فعال‌تر نگه می‌دارد.',
          'اگر تعداد مشتریان رشد کند ولی میانگین خرید افت کند: رشد مشتری صرفاً کمی است، نه کیفی؛ رستوران در جذب مشتری موفق بوده اما در نگهداشت او ضعیف عمل کرده و باید روی تجربه مشتری و برنامه‌های بازگشت سرمایه‌گذاری کند.',
          'اگر تعداد مشتریان ثابت یا نزولی باشد ولی میانگین خرید رشد کند: رستوران مشتری تازه کمتری جذب می‌کند، اما مشتریان موجود وفادارتر شده‌اند؛ نشانه‌ای برای تمرکز بیشتر روی جذب مشتری جدید در کنار حفظ کیفیت فعلی.',
        ],
      },
      {
        title: 'اقدام پیشنهادی',
        style: 'bullet',
        items: [
          'ارائه هدیه برای خرید بعدی',
          'ترغیب مشتری جدید به تکرار خرید، از طریق کمپین‌های وفاداری (ایونت)',
          'بررسی تجربه سفارش (کیفیت غذا، سرعت سرویس، تجربه پرداخت) برای یافتن علت افت بازگشت مشتری',
        ],
      },
    ],
  },

  purchaseCountGroupingTable: {
    title: 'راهنمای جدول «گروه‌بندی بر اساس تعداد خرید»',
    description: 'این جدول مشتریان را بر اساس تعداد دفعاتی که در یک بازه زمانی مشخص خرید کرده‌اند دسته‌بندی می‌کند.',
    interpretation: '',
    sections: [
      {
        title: 'نکته کلیدی در نحوه محاسبه (مهم‌ترین نکته برای درک جدول)',
        style: 'none',
        items: [
          'هر ستون (یک ماه اخیر، دو ماه اخیر، سه ماه اخیر، شش ماه اخیر، یک سال اخیر) یک بازه زمانی مستقل است که از امروز به عقب شمرده می‌شود، نه یک بازه‌ی جداگانه و غیرهم‌پوشان.',
          'برای هر بازه، تعداد خرید هر مشتری فقط داخل همان بازه شمرده می‌شود. به همین دلیل یک مشتری می‌تواند در ستون‌های مختلف در سطرهای متفاوتی قرار بگیرد؛ مثلاً مشتری‌ای که در یک ماه اخیر فقط یک‌بار خرید کرده («تک‌خرید» در ستون یک ماه اخیر)، ممکن است دو ماه قبل از آن هم یک خرید دیگر ثبت کرده باشد و در نتیجه در ستون «سه ماه اخیر» به‌عنوان «دو خرید» شمرده شود. پس ستون‌ها را نباید مجموع یا زیرمجموعه هم دید؛ هرکدام یک عکس مستقل از رفتار مشتری در طول آن بازه هستند.',
        ],
      },
      {
        title: 'تعریف سطرهای خاص',
        style: 'bullet',
        items: [
          'مشتریان غیرفعال در یک سال گذشته: مشتریانی که آخرین خریدشان بیش از یک سال پیش بوده و از آن زمان هیچ سفارشی ثبت نکرده‌اند (فارغ از اینکه در طول عمرشان چند بار خرید کرده بودند).',
          'مجموع: تعداد کل مشتریانی که در طول کل عمرشان با رستوران، دقیقاً همان تعداد خرید (سطر) را داشته‌اند؛ این ستون بر خلاف بقیه، به یک بازه زمانی خاص محدود نیست.',
        ],
      },
      {
        title: 'چرا این جدول مهم است؟',
        style: 'none',
        items: [
          'این جدول به‌جای یک عدد ثابت، روند تبدیل مشتری تازه به مشتری وفادار را در طول زمان نشان می‌دهد. با مقایسه یک سطر (مثلاً تک‌خرید) در ستون‌های مختلف، می‌توان فهمید با گذشت زمان چه سهمی از مشتریان تازه‌وارد، به خرید دوم و سوم می‌رسند و چه سهمی همان‌جا متوقف می‌مانند.',
        ],
      },
      {
        title: 'نحوه خواندن جدول: حرکت افقی به‌جای عمودی',
        style: 'none',
        items: [
          'نکته اصلی تحلیل این جدول، مقایسه افقی هر سطر بین ستون‌های مختلف است، نه فقط نگاه به یک عدد در یک ستون:',
        ],
      },
      {
        title: 'الگوهای افقی',
        style: 'bullet',
        items: [
          'اگر سهم «تک‌خرید» با بازتر شدن بازه زمانی (از یک ماه به سه ماه، شش ماه، یک سال) خیلی کم کاهش پیدا کند، یعنی اکثر مشتریانی که یک‌بار خرید کرده‌اند، حتی با گذشت زمان هم به خرید دوم نمی‌رسند؛ این یعنی مشکل در تبدیل مشتری تازه به مشتری تکراری وجود دارد.',
          'اگر سهم «تک‌خرید» با بازتر شدن بازه زمانی به‌سرعت کاهش پیدا کند و به سمت سطرهای «دو خرید»، «سه خرید» و بالاتر منتقل شود، یعنی مشتریان تازه‌وارد به‌خوبی به مشتری تکراری تبدیل می‌شوند.',
          'ستون «غیرفعال در یک سال گذشته» در کنار سطرهای بالا (سه خرید به بالا) نشان می‌دهد چه تعداد از مشتریانی که قبلاً واقعاً وفادار بوده‌اند، ریزش کرده‌اند؛ این گران‌ترین نوع از دست دادن مشتری برای هر رستوران است.',
        ],
      },
      {
        title: 'بازه زمانی مناسب برای بررسی و آستانه هشدار، بر اساس نوع رستوران',
        style: 'bullet',
        items: [
          'فست‌فود/رستوران محلی داخل شهر با مشتری محله‌ای (سفارش مکرر، هفتگی) — بازه ۱ تا ۲ ماه: اگر بالای ۵۵ تا ۶۰٪ مشتریان در بازه ۲ ماهه هنوز «تک‌خرید» باشند، هشدار جدی است؛ در این مدل، مشتری باید ظرف چند هفته دوباره سفارش دهد.',
          'رستوران خانوادگی/کژوال معمولی شهری (سفارش ماهانه) — بازه ۳ ماه: اگر بالای ۵۰٪ مشتریان در بازه ۳ ماهه هنوز تک‌خرید باشند، جای نگرانی دارد.',
          'رستوران بین‌راهی، جاده‌ای، گردشگری، خارج از شهر — بازه ۱۲ ماه (یک سال): تک‌خرید بالا (حتی تا ۸۰ تا ۹۰٪) در این مدل طبیعی است چون مشتری غالباً مسافر است، نه ساکن دائم؛ در این حالت به‌جای این جدول، رشد تعداد مشتریان جدید ماهانه شاخص مهم‌تری است.',
          'رستوران‌های خاص/مناسبتی، رستوران‌های گران‌قیمت (سفارش هر چند ماه یک‌بار) — بازه ۶ تا ۱۲ ماه: تحمل تک‌خرید بالاتر (تا حدود ۷۰٪) طبیعی است؛ باید سهم «دو خرید» و «سه خرید» در بازه ۶ تا ۱۲ ماه بررسی شود، نه بازه یک یا دو ماه.',
        ],
      },
      {
        title: 'نکته مهم',
        style: 'none',
        items: [
          'این اعداد آستانه‌های تقریبی و مبتنی بر منطق رفتار مشتری در هر مدل کسب‌وکارند، نه استاندارد رسمی صنعت رستوران‌داری. مهم‌تر از عدد مطلق در یک ماه مشخص، روند ماه‌به‌ماه همین جدول است: آیا سهم مشتریانی که از «تک‌خرید» به «دو خرید» یا بالاتر منتقل می‌شوند، در طول زمان بهتر می‌شود یا بدتر؟',
        ],
      },
      {
        title: 'نکته اصلاحی: قیمت به‌تنهایی ملاک نیست، «نوع نیاز مشتری» ملاک است',
        style: 'none',
        items: [
          'نباید صرفاً بر اساس گران یا ارزان بودن رستوران قضاوت کرد. ملاک واقعی این است که غذای آن رستوران برای مشتریانش در دسته «هوس/عادت تکرارشونده» جای می‌گیرد یا در دسته «رویداد خاص و کم‌تکرار».',
        ],
      },
      {
        title: 'انواع رستوران از نظر نوع نیاز',
        style: 'bullet',
        items: [
          'رستوران‌های تخصصی/نیچ با مشتری وفادار خاص خودشان (مثلاً سوشی، برگر گورمه، یک غذای خاص و شناخته‌شده): حتی با قیمت بالا، برای مشتریان علاقه‌مندشان بیشتر شبیه یک «هوس تکرارشونده» عمل می‌کند تا یک مناسبت خاص. این مشتریان می‌توانند به همان اندازه یک فست‌فود معمولی، یا حتی بیشتر، به رستوران برگردند. برای این نوع رستوران‌ها، باید بازه بررسی کوتاه‌تری (مثلاً ۱ تا ۳ ماه) در نظر گرفت، نه بازه بلند ۶ تا ۱۲ ماهه‌ای که برای رستوران‌های مناسبتی صرف پیشنهاد شد.',
          'رستوران‌های واقعاً مناسبتی (جشن تولد، سالگرد، مهمانی رسمی، رستوران‌های فاین‌داینینگ برای مناسبت خاص): اینجا حتی مشتری علاقه‌مند هم به‌ندرت برمی‌گردد، چون خودِ ماهیت مصرف، وابسته به وجود یک مناسبت است، نه میل شخصی به آن غذا. این‌ها همچنان باید با بازه بلند (۶ تا ۱۲ ماه) سنجیده شوند.',
        ],
      },
      {
        title: 'راه تشخیص عملی',
        style: 'none',
        items: [
          'اگر مشتریان یک رستوران گران‌قیمت را «طرفدار» آن رستوران/آن غذای خاص می‌دانید (نه فقط کسی که یک‌بار برای یک مناسبت رفته)، باید آن را در گروه فست‌فود/رستوران محلی از نظر بازه زمانی بررسی کرد (۱ تا ۳ ماه)، نه در گروه رستوران‌های مناسبتی، حتی اگر سطح قیمتش شبیه آن‌ها باشد.',
        ],
      },
    ],
  },

  purchaseDistanceLastYearTable: {
    title: 'راهنمای جدول «فاصله خرید مجدد مشتریان» (یک سال اخیر)',
    description: 'این جدول نشان می‌دهد مشتریان، بر اساس تعداد خریدی که تاکنون داشته‌اند، معمولاً بعد از چند روز برای خرید بعدی به رستوران برگشته‌اند. ستون‌های ۲۵٪، ۵۰٪، ۷۵٪ و ۹۰٪ نشان می‌دهند چه سهمی از مشتریان تا چند روز بعد، خرید بعدی خود را انجام داده‌اند. برای مثال اگر در سطر «یک به دو خرید»، مقدار ۵۰٪ برابر ۶۰ روز باشد، یعنی نیمی از مشتریانی که خرید دوم داشته‌اند، تا ۶۰ روز بعد از خرید اول برگشته‌اند. فاصله خرید کل مشتریان یک سال اخیر: فقط رفتار مشتریانی که در یک سال اخیر خرید کرده‌اند را بررسی می‌کند.',
    interpretation: 'مبنای اصلی تفسیر و تصمیم‌گیری باید همیشه نسخه یک سال اخیر باشد، چون به وضعیت فعلی کسب‌وکار نزدیک‌تر است. این جدول زمان‌بندی تصمیم‌ها برای بازگرداندن مشتری را دقیق می‌کند و نقطه دقیق شروع ریزش مشتری را مشخص می‌سازد. برخلاف جدول «گروه‌بندی بر اساس تعداد خرید» که فقط می‌گفت مشتری در چه بازه‌ای غیرفعال شده، این جدول می‌گوید دقیقاً چند روز، ریتم طبیعی هر مشتری برای بازگشت است؛ یعنی مبنای عینی برای تشخیص «این مشتری دیر کرده» به‌جای حدس زدن.',
    sections: [
      {
        title: 'اقدام پیشنهادی',
        style: 'bullet',
        items: [
          'برای تحریک خرید زودهنگام: مدت زمان اعتبار شروط (مثلاً کد تخفیف یا اعتبار باشگاه مشتریان) بهتر است نزدیک به عدد ستون ۲۵٪ باشد و حتماً پیش از رسیدن به عدد ستون ۵۰٪ منقضی شود؛ در این حالت مشتری با انگیزه‌ای که هنوز در بازه طبیعی رفتارش قرار دارد، ترغیب به خرید سریع‌تر می‌شود.',
          'برای جلوگیری از ریزش: باید دقیقاً وقتی مشتری از ریتم طبیعی خرید خودش خارج شده پیام ارسال شود: اولین پیام یادآوری، نزدیک عدد ستون ۵۰٪. پیام دوم، با پیشنهاد جذاب‌تر (مثلاً تخفیف بزرگ‌تر)، پیش از رسیدن به عدد ستون ۷۵٪.',
          'این زمان‌بندی باعث می‌شود پیام‌ها دقیقاً در لحظه‌ای به دست مشتری برسند که او واقعاً در آستانه ریزش قرار گرفته، نه زودتر (که پیام را نادیده می‌گیرد چون هنوز طبق روال خودش رفتار می‌کند) و نه دیرتر (که مشتری از قبل ذهنیتش را از رستوران دور کرده).',
        ],
      },
      {
        title: 'نکته',
        style: 'none',
        items: [
          'در حال حاضر امکان ساخت خودکار رویداد و ارسال پیام در زمان مشخص (بر اساس همین اعداد) در نرم‌افزار وجود ندارد. این قابلیت به‌عنوان یکی از امکانات آینده به نرم‌افزار اضافه خواهد شد.',
        ],
      },
      {
        title: 'نکته تحلیلی: چرا باید هر سطر را جداگانه خواند',
        style: 'none',
        items: [
          'عدد فاصله خرید مجدد، ثابت نیست و با افزایش سابقه خرید مشتری تغییر می‌کند. طبیعی است که فاصله خرید در سطر «تک‌خرید به دو خرید» با سطر «شش خرید به بالا» متفاوت باشد؛ چون هرچه مشتری به رستوران وفادارتر شده، معمولاً ریتم بازگشتش هم منظم‌تر و کوتاه‌تر می‌شود.',
          'به همین دلیل، پیام یادآوری و اعتبار تشویقی نباید برای همه مشتریان یکسان طراحی شود؛ بلکه باید بر اساس همین جدول، برای هر گروه (بر مبنای تعداد خریدشان تا امروز) با زمان‌بندی مخصوص به خودشان ارسال شود. مثلاً مشتری‌ای که تازه یک خرید داشته، ریتم متفاوتی از مشتری‌ای دارد که پنج خرید داشته و اگر با یک زمان‌بندی مشترک به هر دو گروه پیام داده شود، برای یکی زودهنگام و برای دیگری دیرهنگام خواهد بود.',
          'روند این اعداد در طول ماه‌های مختلف نیز قابل پایش است: اگر فاصله خرید مجدد در یک سطر مشخص (مثلاً یک به دو خرید) به‌تدریج در حال طولانی‌تر شدن باشد، حتی پیش از آنکه در جدول «گروه‌بندی تعداد خرید» به‌صورت افت آشکار شود، یک هشدار زودهنگام از سست‌شدن ارتباط مشتریان با رستوران است.',
        ],
      },
    ],
  },

  purchaseDistanceAllCustomersTable: {
    title: 'راهنمای جدول «فاصله خرید مجدد مشتریان» (کل مشتریان)',
    description: 'فاصله خرید کل مشتریان: رفتار همه مشتریان رستوران در طول تمام سال‌های فعالیت را در نظر می‌گیرد. ستون‌های ۲۵٪، ۵۰٪، ۷۵٪ و ۹۰٪ نشان می‌دهند چه سهمی از مشتریان تا چند روز بعد، خرید بعدی خود را انجام داده‌اند.',
    interpretation: 'نسخه «کل مشتریان» بیشتر برای دیدن روند بلندمدت و مقایسه با وضعیت فعلی کاربرد دارد، نه تصمیم‌گیری عملیاتی روزمره. مبنای اصلی تفسیر و تصمیم‌گیری باید همیشه نسخه یک سال اخیر باشد، چون به وضعیت فعلی کسب‌وکار نزدیک‌تر است.',
    sections: [
      {
        title: 'اقدام پیشنهادی',
        style: 'bullet',
        items: [
          'برای تحریک خرید زودهنگام: مدت زمان اعتبار شروط (مثلاً کد تخفیف یا اعتبار باشگاه مشتریان) بهتر است نزدیک به عدد ستون ۲۵٪ باشد و حتماً پیش از رسیدن به عدد ستون ۵۰٪ منقضی شود.',
          'برای جلوگیری از ریزش: اولین پیام یادآوری، نزدیک عدد ستون ۵۰٪. پیام دوم، با پیشنهاد جذاب‌تر (مثلاً تخفیف بزرگ‌تر)، پیش از رسیدن به عدد ستون ۷۵٪.',
        ],
      },
      {
        title: 'نکته',
        style: 'none',
        items: [
          'در حال حاضر امکان ساخت خودکار رویداد و ارسال پیام در زمان مشخص (بر اساس همین اعداد) در نرم‌افزار وجود ندارد. این قابلیت به‌عنوان یکی از امکانات آینده به نرم‌افزار اضافه خواهد شد.',
        ],
      },
      {
        title: 'نکته تحلیلی: چرا باید هر سطر را جداگانه خواند',
        style: 'none',
        items: [
          'پیام یادآوری و اعتبار تشویقی نباید برای همه مشتریان یکسان طراحی شود؛ بلکه باید بر اساس همین جدول، برای هر گروه (بر مبنای تعداد خریدشان تا امروز) با زمان‌بندی مخصوص به خودشان ارسال شود.',
        ],
      },
    ],
  },

  purchaseDistanceComparisonTable: {
    title: 'راهنمای جدول «مقایسه ریتم بازگشت مشتریان»',
    description: 'این جدول تفاوت فاصله خرید مجدد بین «یک سال اخیر» و «کل دوره» را برای هر گروه تعداد خرید و هر صدک (۲۵٪، ۵۰٪، ۷۵٪، ۹۰٪) نشان می‌دهد. جایگزین دو جدول فاصله خرید نیست؛ بلکه تحلیل تفاوت آن‌هاست.',
    interpretation: 'Δ منفی (سبز) یعنی مشتریان اخیراً زودتر برمی‌گردند — فاصله خرید کوتاه‌تر شده. Δ مثبت (قرمز) یعنی دیرتر مراجعه می‌کنند — هشدار سست‌شدن وفاداری. وضعیت کلی هر سطر بر اساس P50 (میانه) محاسبه می‌شود.',
    sections: [
      {
        title: 'چگونه بخوانیم؟',
        style: 'bullet',
        items: [
          'ستون «کل دوره»: ریتم تاریخی بلندمدت (مرجع).',
          'ستون «یک سال اخیر»: رفتار فعلی مشتریان فعال.',
          'Δ روز: تفاوت مطلق به روز — منفی = زودتر، مثبت = دیرتر.',
          'Δ ٪: تفاوت نسبی — برای مقایسه بین گروه‌های مختلف (مثلاً «یک خرید» در برابر «شش خرید»).',
          'تغییر ناچیز: |Δ روز| ≤ ۳ و |Δ ٪| ≤ ۵٪.',
        ],
      },
      {
        title: 'اقدام پیشنهادی',
        style: 'bullet',
        items: [
          'اگر P50 دیرتر شده: زمان‌بندی پیام یادآوری و اعتبار تشویقی را بازبینی کنید (ارجاع به جدول فاصله خرید یک سال اخیر).',
          'اگر P50 زودتر شده: ریتم وفاداری تقویت شده — می‌توانید زمان اعتبار را کوتاه‌تر کنید.',
          'هر سطر را جداگانه بخوانید — ریتم «تک‌خرید» با «شش خرید به بالا» متفاوت است.',
        ],
      },
      {
        title: 'نکته تحلیلی',
        style: 'none',
        items: [
          'اختلاف زیاد بین یک سال اخیر و کل دوره، حتی پیش از افت آشکار در جدول «گروه‌بندی تعداد خرید»، هشدار زودهنگام از تغییر رفتار مشتریان است.',
        ],
      },
    ],
  },

  purchaseBehaviorComposition: {
    title: 'راهنمای «ترکیب گروه‌های خرید در هر ماه»',
    description: 'سهم هر گروه از کل سفارشات هر ماه را نشان می‌دهد؛ یعنی از کل سفارشات ماه، چند درصد (یا چه تعداد) توسط مشتری بار اول، بار دوم، تا بار ششم و بیشتر ثبت شده است. دو حالت نمایش دارد: عددی و درصدی. فرمول (حالت درصدی): سهم هر گروه = تعداد سفارش آن گروه در ماه ÷ کل سفارشات همان ماه.',
    interpretation: '',
    sections: [
      {
        title: 'تحلیل ترکیبی: ترکیب گروه‌های خرید + روند یک گروه',
        style: 'none',
        items: [
          'نمودار «ترکیب گروه‌های خرید» فقط وضعیت یک ماه را نشان می‌دهد و به‌تنهایی نمی‌گوید این وضعیت رو به بهبود است یا رو به وخامت. باید سهم یک گروه خاص (مثلاً مشتری بار اول) را در طول چند ماه متوالی در نمودار «روند یک گروه» دنبال کرد تا فهمید آیا رستوران دارد در نگه‌داشتن مشتری بهتر عمل می‌کند یا بدتر.',
        ],
      },
      {
        title: 'اقدام',
        style: 'bullet',
        items: [
          'اگر سهم مشتری بار اول در حال افزایش و سهم مشتریان تکراری در حال کاهش است، باید کمپین یا پیشنهاد تشویق خرید دوم راه‌اندازی شود (مثلاً کد تخفیف برای بازگشت).',
        ],
      },
      {
        title: 'مسیر پیشنهادی کامل بررسی',
        style: 'decimal',
        items: [
          '«ترکیب گروه‌های خرید» → وضعیت فعلی را ببینید.',
          '«رشد: جدید و بازگشتی» → بفهمید تغییر این ماه از کیفیت آمده (بازگشت مشتری) یا از کمیت (جذب تازه).',
          '«رشد هر گروه (٪)» → همان تغییر را ریزتر کنید و ببینید دقیقاً کدام سطح از مشتری مسئول آن بوده.',
          '«تغییر تعداد هر گروه» → وزن واقعی آن تغییر را از نظر تعداد سفارش بسنجید، نه فقط درصد.',
          '«روند یک گروه» → با دنبال کردن همان گروه در طول یک سال، تأیید کنید این تغییر یک روند واقعی است یا یک نوسان یک‌ماهه.',
        ],
      },
    ],
  },

  purchaseBehaviorNewVsReturningGrowth: {
    title: 'راهنمای «رشد: جدید و بازگشتی»',
    description: 'درصد تغییر تعداد سفارش‌های «مشتری جدید» (بار اول) و «مشتری بازگشتی» (بار دوم به بعد) را نسبت به ماه قبل، در کنار رشد کل سفارشات نشان می‌دهد. فرمول: رشد هر گروه = (تعداد سفارش آن گروه در این ماه − تعداد سفارش آن گروه در ماه قبل) ÷ تعداد سفارش آن گروه در ماه قبل.',
    interpretation: '',
    sections: [
      {
        title: 'تحلیل ترکیبی: رشد: جدید و بازگشتی + رشد هر گروه (٪)',
        style: 'none',
        items: [
          'وقتی نمودار «رشد: جدید و بازگشتی» نشان می‌دهد رشد از محل مشتری بازگشتی بوده، این خبر خوبی است ولی کافی نیست؛ باید با نمودار «رشد هر گروه» دقیق‌تر دید کدام سطح از مشتری وفادار (مثلاً بار دوم یا بار ششم) این رشد را رقم زده. رشدی که از مشتریان بار دوم می‌آید (تازه دارند به وفاداری می‌رسند) با رشدی که از مشتریان بار ششم می‌آید (هسته سفت‌وسخت وفادار) دو معنای متفاوت دارند و نیاز به اقدام متفاوتی هم دارند.',
        ],
      },
      {
        title: 'اقدام',
        style: 'bullet',
        items: [
          'اگر رشد از گروه‌های تازه‌وفادارشده (بار دوم/سوم) آمده، باید با پیام و پیشنهاد مناسب، آن‌ها را به سمت خرید سوم و چهارم هدایت کرد تا این وفاداری تازه از دست نرود.',
        ],
      },
      {
        title: 'مسیر پیشنهادی کامل بررسی',
        style: 'decimal',
        items: [
          '«ترکیب گروه‌های خرید» → وضعیت فعلی را ببینید.',
          '«رشد: جدید و بازگشتی» → بفهمید تغییر این ماه از کیفیت آمده (بازگشت مشتری) یا از کمیت (جذب تازه).',
          '«رشد هر گروه (٪)» → همان تغییر را ریزتر کنید و ببینید دقیقاً کدام سطح از مشتری مسئول آن بوده.',
          '«تغییر تعداد هر گروه» → وزن واقعی آن تغییر را از نظر تعداد سفارش بسنجید، نه فقط درصد.',
          '«روند یک گروه» → با دنبال کردن همان گروه در طول یک سال، تأیید کنید این تغییر یک روند واقعی است یا یک نوسان یک‌ماهه.',
        ],
      },
    ],
  },

  purchaseBehaviorGroupGrowthPercent: {
    title: 'راهنمای «رشد هر گروه (٪)»',
    description: 'همان فرمول نمودار «رشد: جدید و بازگشتی» است، با این تفاوت که به‌جای دو دسته کلی (جدید/بازگشتی)، برای هر ۶ گروه به‌طور جداگانه محاسبه و نمایش داده می‌شود.',
    interpretation: '',
    sections: [
      {
        title: 'تحلیل ترکیبی: رشد هر گروه (٪) + تغییر تعداد هر گروه',
        style: 'none',
        items: [
          'این دو نمودار همیشه باید با هم خوانده شوند، هرگز جدا از هم. درصد به‌تنهایی گمراه‌کننده است: یک گروه کوچک با تغییر جزئی می‌تواند درصد رشد بسیار بزرگی نشان دهد، در حالی‌که اثر واقعی‌اش روی کسب‌وکار ناچیز است. قانون ساده: هر عددی که در نمودار «رشد هر گروه» چشمگیر به نظر می‌رسد، باید بلافاصله در نمودار «تغییر تعداد هر گروه» چک شود تا معلوم شود این تغییر از نظر تعداد واقعی سفارش هم بزرگ بوده یا فقط یک نوسان کوچک با درصد بزرگ در یک گروه کم‌حجم است.',
        ],
      },
      {
        title: 'اقدام',
        style: 'bullet',
        items: [
          'اولویت کمپین و بودجه بازاریابی باید روی گروهی گذاشته شود که در نمودار «تغییر تعداد هر گروه» عدد بزرگ‌تری نشان می‌دهد، نه صرفاً گروهی که درصدش چشمگیرتر است.',
        ],
      },
      {
        title: 'مسیر پیشنهادی کامل بررسی',
        style: 'decimal',
        items: [
          '«ترکیب گروه‌های خرید» → وضعیت فعلی را ببینید.',
          '«رشد: جدید و بازگشتی» → بفهمید تغییر این ماه از کیفیت آمده (بازگشت مشتری) یا از کمیت (جذب تازه).',
          '«رشد هر گروه (٪)» → همان تغییر را ریزتر کنید و ببینید دقیقاً کدام سطح از مشتری مسئول آن بوده.',
          '«تغییر تعداد هر گروه» → وزن واقعی آن تغییر را از نظر تعداد سفارش بسنجید، نه فقط درصد.',
          '«روند یک گروه» → با دنبال کردن همان گروه در طول یک سال، تأیید کنید این تغییر یک روند واقعی است یا یک نوسان یک‌ماهه.',
        ],
      },
    ],
  },

  purchaseBehaviorGroupCountChange: {
    title: 'راهنمای «تغییر تعداد هر گروه»',
    description: 'به‌جای درصد رشد، عدد خام تغییر تعداد سفارش هر گروه نسبت به ماه قبل را نشان می‌دهد. فرمول: تغییر تعداد = تعداد سفارش آن گروه در این ماه − تعداد سفارش آن گروه در ماه قبل.',
    interpretation: '',
    sections: [
      {
        title: 'تحلیل ترکیبی: رشد هر گروه (٪) یا تغییر تعداد هر گروه + روند یک گروه',
        style: 'none',
        items: [
          'وقتی یکی از این دو نمودار نشان می‌دهد یک گروه خاص در این ماه تغییر بزرگی داشته، قبل از هر تصمیمی باید همان گروه را در نمودار «روند یک گروه» باز کرد. اگر خط روند آن گروه در طول سال هم در همان جهت (صعودی یا نزولی) بوده، یعنی این یک الگوی واقعی و پایدار است. اگر خط روند برخلاف تغییر این ماه بوده (مثلاً روند کلی صعودی ولی این یک ماه افت داشته)، یعنی احتمالاً یک نوسان موقت بوده و نباید عجولانه نتیجه‌گیری کرد.',
        ],
      },
      {
        title: 'اقدام',
        style: 'bullet',
        items: [
          'فقط زمانی که یک تغییر هم از نظر تعداد قابل‌توجه باشد و هم در روند بلندمدت تأیید شود، ارزش دارد که رستوران بر اساس آن تصمیم بزرگ (تغییر منو، کمپین گسترده، تغییر قیمت) بگیرد؛ در غیر این صورت، احتمالاً فقط با یک نوسان ماهانه طبیعی روبه‌رو هستید و بهتر است قبل از هر اقدام بزرگ، یکی دو ماه دیگر صبر کرد و دوباره روند را چک کرد.',
        ],
      },
      {
        title: 'مسیر پیشنهادی کامل بررسی',
        style: 'decimal',
        items: [
          '«ترکیب گروه‌های خرید» → وضعیت فعلی را ببینید.',
          '«رشد: جدید و بازگشتی» → بفهمید تغییر این ماه از کیفیت آمده (بازگشت مشتری) یا از کمیت (جذب تازه).',
          '«رشد هر گروه (٪)» → همان تغییر را ریزتر کنید و ببینید دقیقاً کدام سطح از مشتری مسئول آن بوده.',
          '«تغییر تعداد هر گروه» → وزن واقعی آن تغییر را از نظر تعداد سفارش بسنجید، نه فقط درصد.',
          '«روند یک گروه» → با دنبال کردن همان گروه در طول یک سال، تأیید کنید این تغییر یک روند واقعی است یا یک نوسان یک‌ماهه.',
        ],
      },
    ],
  },

  purchaseBehaviorGroupTrend: {
    title: 'راهنمای «روند یک گروه»',
    description: 'مسیر یک گروه مشخص (یا کل سفارشات) را در طول یک سال گذشته نشان می‌دهد، همراه با یک خط روند که جهت کلی (صعودی یا نزولی) را مشخص می‌کند.',
    interpretation: '',
    sections: [
      {
        title: 'مسیر پیشنهادی کامل بررسی',
        style: 'decimal',
        items: [
          '«ترکیب گروه‌های خرید» → وضعیت فعلی را ببینید.',
          '«رشد: جدید و بازگشتی» → بفهمید تغییر این ماه از کیفیت آمده (بازگشت مشتری) یا از کمیت (جذب تازه).',
          '«رشد هر گروه (٪)» → همان تغییر را ریزتر کنید و ببینید دقیقاً کدام سطح از مشتری مسئول آن بوده.',
          '«تغییر تعداد هر گروه» → وزن واقعی آن تغییر را از نظر تعداد سفارش بسنجید، نه فقط درصد.',
          '«روند یک گروه» → با دنبال کردن همان گروه در طول یک سال، تأیید کنید این تغییر یک روند واقعی است یا یک نوسان یک‌ماهه.',
        ],
      },
    ],
  },

  smsChargeMonthlyTable: {
    title: 'راهنمای جدول روزهای بدون شارژ پیامک',
    description: 'این جدول تعداد روزهایی که شعبه در هر ماه فاقد شارژ پیامک بوده را به همراه مجموع کل دوره نمایش می‌دهد.',
    interpretation: 'هرچه تعداد روزهای بدون شارژ بیشتر باشد، فرصت‌های بیشتری برای ارتباط پیامکی با مشتریان غیر فعال است. مجموع پایین‌تر مطلوب‌تر است.',
    tips: [
      'ماه‌هایی با روزهای بدون شارژ بالا را برای پیگیری شارژ به‌موقع اولویت دهید',
      'برای جلوگیری از قطع شدن پیامک، شارژ خودکار یا یادآور تنظیم کنید',
      'روند ماه‌به‌ماه را برای شناسایی الگوی قطعی شارژ بررسی کنید'
    ]
  },

  // HR Dashboard Charts
  personnelPerformanceDistribution: {
    title: 'راهنمای توزیع عملکرد پرسنل',
    description: 'این نمودار توزیع عملکرد کارکنان را در سطوح مختلف نمایش می‌دهد.',
    interpretation: 'توزیع نرمال با تمایل به سمت عملکرد بالا مطلوب است.',
    tips: [
      'کارکنان با عملکرد پایین را برای آموزش شناسایی کنید',
      'از کارکنان با عملکرد بالا برای منتورینگ استفاده کنید',
      'سیستم پاداش متناسب با توزیع عملکرد طراحی کنید'
    ]
  },

  teamComposition: {
    title: 'راهنمای ترکیب تیم',
    description: 'این نمودار ترکیب تیم را بر اساس نقش، تجربه و مهارت نمایش می‌دهد.',
    interpretation: 'ترکیب متوازن تیم به عملکرد بهتر کمک می‌کند.',
    tips: [
      'کمبودها در نقش‌های خاص را شناسایی کنید',
      'تعادل بین کارکنان باتجربه و تازه‌کار را حفظ کنید',
      'برنامه آموزش برای تقویت نقاط ضعف تیم طراحی کنید'
    ]
  },

  personnelPerformanceByRole: {
    title: 'راهنمای عملکرد پرسنل بر اساس نقش',
    description: 'این نمودار عملکرد را به تفکیک نقش‌های مختلف نمایش می‌دهد.',
    interpretation: 'تفاوت عملکرد بین نقش‌ها می‌تواند نشان‌دهنده نیاز به آموزش یا بازنگری فرآیند باشد.',
    tips: [
      'استانداردهای عملکرد برای هر نقش تعریف کنید',
      'آموزش‌های تخصصی برای هر نقش طراحی کنید',
      'بهترین شیوه‌ها را بین نقش‌های مشابه به اشتراک بگذارید'
    ]
  },

  comparisonPerformanceByRole: {
    title: 'راهنمای مقایسه عملکرد نقش‌ها',
    description: 'این نمودار عملکرد نقش‌های مختلف را با یکدیگر مقایسه می‌کند.',
    interpretation: 'مقایسه به شناسایی نقش‌های نیازمند بهبود کمک می‌کند.',
    tips: [
      'نقش‌های با عملکرد پایین را اولویت‌بندی کنید',
      'دلایل تفاوت عملکرد را تحلیل کنید',
      'منابع را متناسب با نیاز هر نقش تخصیص دهید'
    ]
  },

  keyPerformanceMetrics: {
    title: 'راهنمای معیارهای کلیدی عملکرد',
    description: 'این نمودار KPIهای مهم منابع انسانی را نمایش می‌دهد.',
    interpretation: 'دستیابی به اهداف KPI نشان‌دهنده مدیریت موثر منابع انسانی است.',
    tips: [
      'KPIهای زیر هدف را برای بهبود فوری انتخاب کنید',
      'روند تغییرات را برای پیش‌بینی آینده تحلیل کنید',
      'اهداف را متناسب با واقعیت‌های عملیاتی تنظیم کنید'
    ]
  },

  topPersonnelPerformance: {
    title: 'راهنمای کارکنان برتر',
    description: 'این نمودار کارکنان با بهترین عملکرد را نمایش می‌دهد.',
    interpretation: 'شناسایی و تقدیر از کارکنان برتر به انگیزه کل تیم کمک می‌کند.',
    tips: [
      'از کارکنان برتر به عنوان الگو استفاده کنید',
      'دلایل موفقیت آن‌ها را تحلیل و مستند کنید',
      'سیستم پاداش و تقدیر مناسب طراحی کنید'
    ]
  },

  // Refine Customer Dashboard (additional)
  dissatisfiedProducts: {
    title: 'راهنمای محصولات نارضایتی‌ساز',
    description: 'این نمودار محصولاتی که بیشترین نارضایتی را ایجاد کرده‌اند نمایش می‌دهد.',
    interpretation: 'محصولات با نارضایتی بالا نیاز به بازنگری فوری در کیفیت یا قیمت دارند.',
    tips: [
      'کیفیت محصولات پرشکایت را بررسی کنید',
      'قیمت‌گذاری را با انتظارات مشتریان تطبیق دهید',
      'محصولات جایگزین یا بهبود یافته ارائه دهید'
    ]
  },

  // Satisfaction Dashboard
  overallSatisfaction: {
    title: 'راهنمای تب «نمای کلی» — داشبورد رضایت مشتریان',
    description: 'میانگین رضایت کلی: درصد کل نظراتی که «خوب» یا «عالی» بوده‌اند، از مجموع کل نظرات ثبت‌شده.',
    interpretation: 'روند ماهانه میانگین رضایت کلی را در طول زمان نشان می‌دهد. سه تب دیگر (شیفت‌ها، نوع سفارش، دسته‌بندی‌ها) همین روند رضایت را به‌جای نمایش کلی، به تفکیک شیفت کاری، نوع سفارش، یا دسته‌بندی محصول نشان می‌دهند.',
    sections: [
      {
        title: 'حداقل تعداد نظر قابل استناد در ماه',
        style: 'bullet',
        items: [
          'زیر ۷۰ — غیرقابل استناد',
          '۷۰ تا ۱۵۰ — قابل قبول برای تصمیم‌گیری‌های معمول ماهانه',
          '۱۵۰+ — دقت بالا؛ مناسب برای تصمیمات مهم و پرهزینه (مثل تغییر منو یا قیمت)',
        ],
      },
    ],
  },

  detailedSatisfaction: {
    title: 'راهنمای تب «دسته‌بندی‌ها» — داشبورد رضایت مشتریان',
    description: 'این تب، برخلاف تب‌های «شیفت‌ها» و «نوع سفارش» که رضایت کلی را بین گروه‌های مختلف مشتری تقسیم می‌کردند، رضایت کلی را به اجزای سازنده‌اش می‌شکند؛ یعنی نشان می‌دهد از میان همه سؤالات نظرسنجی، رضایت از هر جنبه مشخص به‌طور جداگانه چقدر بوده است. سؤالات نظرسنجی و دسته‌بندی آن‌ها می‌تواند برای هر رستوران متفاوت باشد؛ برای هر زیرمعیار، هم یک کارت با آخرین درصد رضایت و هم یک خط روند ماهانه جداگانه نمایش داده می‌شود.',
    interpretation: '',
    sections: [
      {
        title: 'نکته کاربردی',
        style: 'none',
        items: [
          'این تب دقیقاً همان چیزی است که وقتی عدد رضایت کلی افت یا رشد غیرمنتظره‌ای نشان می‌دهد، باید به آن مراجعه کرد. رضایت کلی فقط می‌گوید «یک چیزی تغییر کرده»؛ این تب می‌گوید «دقیقاً کدام جنبه». برای مثال اگر رضایت کلی افت کرده ولی در این تب فقط «سرعت آماده‌سازی غذا» افت نشان می‌دهد و بقیه زیرمعیارها ثابت‌اند، مشکل مشخصاً به کندی آشپزخانه برمی‌گردد، نه به کیفیت غذا یا رفتار پرسنل.',
          'یک تفاوت مهم این تب با تب‌های «شیفت‌ها» و «نوع سفارش» در اعتبار آماری‌شان است: در آن دو تب، هر گروه فقط شامل بخشی از کل نظرات بود (چون مشتریان بین شیفت‌ها یا انواع سفارش تقسیم می‌شدند)، پس تعداد نظر هر گروه کوچک‌تر از کل بود. اما در این تب، هر زیرمعیار یک سؤال جداگانه از همان مجموعه نظرات کلی است، نه یک زیرمجموعه کوچک‌تر از مشتریان؛ یعنی تعداد پاسخ هر زیرمعیار تقریباً برابر با کل نظرات ثبت‌شده آن ماه است. به همین دلیل، نگرانی «نمونه کوچک» که برای تب‌های شیفت و نوع سفارش مهم بود، در این تب کمتر مطرح است، به شرطی که خود عدد کل نظرات ماه از حد قابل استناد عبور کرده باشد.',
        ],
      },
    ],
  },

  orderTypeSatisfaction: {
    title: 'راهنمای تب «نوع سفارش» — داشبورد رضایت مشتریان',
    description: 'این تب دو نمای مکمل دارد: نمودار رضایت مشتریان — روند ماهانه درصد رضایت را به‌طور جداگانه برای هر نوع سفارش (سالن، بسته‌بندی، دلیوری، اسنپ) نشان می‌دهد؛ یعنی چهار خط، هرکدام مربوط به یک نوع سفارش. جدول تعداد نظرسنجی‌ها — تعداد نظراتی که در هر ماه، از هر نوع سفارش ثبت شده است؛ همراه با درصد رضایت همان نوع سفارش در همان ماه (عدد داخل پرانتز)، و یک ستون «مجموع» که کل نظرات آن ماه از همه انواع سفارش را جمع می‌زند.',
    interpretation: 'وقتی تعداد نظرات کافی باشد، فاصله رضایت بین انواع سفارش معمولاً یک معنای عملیاتی مشخص دارد، نه یک تفاوت تصادفی:',
    sections: [
      {
        title: 'نکته کاربردی',
        style: 'none',
        items: [
          'این دو نما باید همیشه با هم دیده شوند، نه جدا: نمودار می‌گوید رضایت هر نوع سفارش چقدر بوده، و جدول می‌گوید آن درصد از چند نظر ساخته شده.',
          'با توجه به حداقل تعداد نظر قابل استناد (زیر ۷۰ نظر در ماه غیرقابل استناد است)، وقتی سهم یک نوع سفارش در یک ماه خاص عدد کمی دارد (مثلاً فقط چند نظر یا حتی صفر)، درصد رضایت همان خانه در نمودار عملاً غیرقابل استناد است، حتی اگر عدد کل آن ماه (ستون مجموع) از حد کافی عبور کرده باشد. به همین دلیل، پیش از نتیجه‌گیری درباره افت یا رشد رضایت یک نوع سفارش خاص، باید حتماً تعداد نظر همان نوع سفارش در جدول چک شود.',
        ],
      },
      {
        title: 'تفسیر',
        style: 'bullet',
        items: [
          'اگر رضایت «سالن» به‌طور پیوسته بالاتر از «دلیوری» یا «اسنپ» باشد، مشکل معمولاً به خود کیفیت غذا ربطی ندارد؛ بلکه به مسیر بعد از خروج غذا از رستوران برمی‌گردد — مثل سرد شدن غذا، طول کشیدن زمان تحویل، یا رفتار پیک. در این حالت، تمرکز اصلی باید روی بسته‌بندی مناسب برای حفظ کیفیت در طول مسیر و زمان تحویل پیک باشد، نه روی آشپزخانه.',
          'اگر رضایت «بسته‌بندی» (سفارش حضوری برای بردن) هم پایین‌تر از «سالن» باشد، این نشان می‌دهد حتی بدون واسطه پیک، صرفاً بیرون بردن غذا کیفیت تجربه را کم می‌کند؛ در این حالت مشکل احتمالاً از نوع بسته‌بندی یا افت کیفیت غذا در فاصله کوتاه بین آماده شدن و مصرف است، نه از پیک یا اپلیکیشن.',
          'اگر رضایت «دلیوری» و «اسنپ» با هم فاصله معناداری داشته باشند (با اینکه هر دو از مسیر تحویل بیرون از رستوران عبور می‌کنند)، این تفاوت را باید در کیفیت سرویس پیک همان پلتفرم خاص یا زمان‌بندی سفارش‌گیری آن پلتفرم جست‌وجو کرد، نه در رستوران.',
          'اگر همه انواع سفارش رضایت نزدیک به هم داشته باشند، یعنی نوع سفارش عامل تعیین‌کننده‌ای در تجربه مشتری نیست و باید علت افت یا رشد رضایت را در جای دیگری (مثلاً کیفیت کلی غذا یا شیفت کاری) جست‌وجو کرد.',
        ],
      },
    ],
  },

  shiftSatisfaction: {
    title: 'راهنمای تب «شیفت‌ها» — داشبورد رضایت مشتریان',
    description: 'نمودار رضایت مشتریان: روند ماهانه درصد رضایت را به‌طور جداگانه برای هر شیفت کاری (صبح، ظهر، عصر، شب) نشان می‌دهد؛ یعنی چهار خط، هرکدام مربوط به یک شیفت. جدول تعداد نظرسنجی‌ها: تعداد نظراتی که در هر ماه، از هر شیفت کاری ثبت شده است؛ همراه با درصد رضایت همان شیفت در همان ماه (عدد داخل پرانتز)، و یک ستون «مجموع» که کل نظرات آن ماه از همه شیفت‌ها را جمع می‌زند.',
    interpretation: '',
    sections: [
      {
        title: 'نکته کاربردی',
        style: 'none',
        items: [
          'این دو نما باید همیشه با هم دیده شوند، نه جدا: نمودار می‌گوید رضایت هر شیفت چقدر بوده، و جدول می‌گوید آن درصد از چند نظر ساخته شده.',
          'با توجه به حداقل تعداد نظر قابل استناد (زیر ۷۰ نظر در ماه غیرقابل استناد است)، وقتی سهم یک شیفت در یک ماه خاص عدد کمی دارد (مثلاً فقط چند نظر)، درصد رضایت همان خانه در نمودار عملاً غیرقابل استناد است، حتی اگر عدد کل آن ماه (ستون مجموع) از حد کافی عبور کرده باشد. به همین دلیل، پیش از نتیجه‌گیری درباره افت یا رشد رضایت یک شیفت خاص، باید حتماً تعداد نظر همان شیفت در جدول چک شود.',
        ],
      },
    ],
  },

  // Subscription Dashboard
  subscriptionDashboard: {
    title: 'راهنمای داشبورد اشتراک‌گیری',
    description: 'این داشبورد روند اشتراک‌گیری مشتریان را در نمای کلی، شیفت کاری و نوع سفارش نمایش می‌دهد.',
    interpretation: 'درصد بالاتر نشان می‌دهد سهم بیشتری از سفارش‌های واجد شرایط به مشتریان عضو یا ثبت شده تبدیل شده‌اند.',
    tips: [
      'روند کلی را برای تشخیص رشد یا افت اشتراک‌گیری بررسی کنید',
      'شیفت‌ها و نوع سفارش‌های ضعیف‌تر را برای آموزش یا اصلاح فرآیند اولویت‌بندی کنید',
      'نتایج را با کمپین‌ها، تغییرات پرسنل و کانال‌های سفارش تطبیق دهید'
    ]
  },

  overallSubscription: {
    title: 'راهنمای روند کلی اشتراک‌گیری',
    description: 'این نمودار درصد اشتراک‌گیری شعبه را در ماه‌های مختلف نمایش می‌دهد.',
    interpretation: 'افزایش پایدار یعنی فرآیند ثبت یا عضویت مشتری در طول زمان بهتر انجام شده است.',
    tips: [
      'افت ناگهانی را با تغییرات عملیاتی همان ماه مقایسه کنید',
      'ماه‌های موفق را الگو قرار دهید و اقدامات مؤثر را تکرار کنید',
      'هدف ماهانه برای حفظ یا رشد درصد اشتراک‌گیری تعیین کنید'
    ]
  },

  shiftSubscription: {
    title: 'راهنمای اشتراک‌گیری بر اساس شیفت',
    description: 'این نمودار درصد اشتراک‌گیری را بین شیفت‌های کاری مقایسه می‌کند.',
    interpretation: 'اختلاف زیاد بین شیفت‌ها می‌تواند نشان‌دهنده تفاوت در آموزش، تراکم کار یا پیگیری پرسنل باشد.',
    tips: [
      'شیفت‌های ضعیف‌تر را از نظر تعداد پرسنل و حجم سفارش بررسی کنید',
      'روش‌های شیفت‌های موفق را به سایر شیفت‌ها منتقل کنید',
      'در ساعات شلوغ، فرآیند ثبت مشتری را ساده‌تر کنید'
    ]
  },

  orderTypeSubscription: {
    title: 'راهنمای اشتراک‌گیری بر اساس نوع سفارش',
    description: 'این نمودار درصد اشتراک‌گیری را برای انواع سفارش مانند سالن، بسته‌بندی، دلیوری، اسنپ و سایت اختصاصی نشان می‌دهد.',
    interpretation: 'کانال‌هایی با درصد پایین‌تر فرصت بهبود در ثبت اطلاعات مشتری یا دعوت به عضویت دارند.',
    tips: [
      'برای هر کانال سفارش پیام یا فرآیند عضویت مناسب طراحی کنید',
      'کانال‌های آنلاین و حضوری را جداگانه تحلیل کنید',
      'در نوع سفارش‌های کم‌عملکرد، مانع اصلی ثبت مشتری را پیدا کنید'
    ]
  },

  // Club Dashboard — پارامترهای فروش
  monthlyPerformance: {
    title: 'راهنمای جدول «عملکرد فروش ماهانه» (پارامترهای فروش)',
    description: 'این جدول شاخص‌های فروش و رفتار خرید ماهانه را نمایش می‌دهد.',
    interpretation: '',
    sections: [
      {
        title: '۱. اشتراک‌گیری (درصد ثبت اطلاعات مشتری)',
        style: 'none',
        items: [
          'تعریف: درصد اشتراک‌گیری یعنی چند درصد از سفارشات، همراه با اطلاعات مشتری (شماره تماس) ثبت شده‌اند.',
          'نحوه محاسبه: تعداد سفارشاتی که شماره تماس مشتری برای آن‌ها ثبت شده، تقسیم بر تعداد کل سفارشات آن ماه.',
          'چرا مهم است؟ تمام تحلیل‌های رفتار مشتری (تعداد مشتری، مشتری وفادار، نرخ بازگشت و...) بر پایه همین داده ساخته می‌شود. اگر این عدد پایین باشد، عملاً پایه و اساس تحلیل مشتری سست است.',
        ],
      },
      {
        title: 'نحوه تفسیر و اقدام (اشتراک‌گیری)',
        style: 'bullet',
        items: [
          '۰٪ تا ۵۰٪ — دیتای مشتری فاقد اعتبار است و عملاً قابل تحلیل نیست: فرآیند ثبت شماره تماس در زمان سفارش (توسط گارسون/کارشناس سفارش‌گیری) باید اصلاح و الزامی شود.',
          '۵۰٪ تا ۷۰٪ — داده ناقص است؛ تحلیل فقط با احتیاط بالا قابل استناد است: علت عدم ثبت در بخشی از سفارشات بررسی و فرآیند سفارش‌گیری اصلاح شود.',
          '۷۰٪ تا ۹۰٪ — سطح قابل قبول؛ داده برای تحلیل و تصمیم‌گیری قابل اتکا است: وضعیت فعلی حفظ و برای رسیدن به بالای ۹۰٪ بهبود تدریجی داده شود.',
          '۹۰٪ تا ۱۰۰٪ — دقت داده‌ها برای تحلیل بالاست: می‌توان با اطمینان بالا روی گزارش‌های مشتری تصمیم‌گیری کرد.',
          '۱۰۰٪ — مشکوک به خطا در ثبت داده: احتمال ثبت شماره تکراری/فیک توسط کارمندان برای عبور از الزام سیستم وجود دارد؛ کیفیت و یکتا بودن شماره‌های ثبت‌شده بررسی شود.',
        ],
      },
      {
        title: 'تعریف سایر شاخص‌ها',
        style: 'decimal',
        items: [
          'تعداد سفارشات — تعریف: تعداد کل سفارش‌های ثبت‌شده در آن ماه. چرا مهم است؟ نشان می‌دهد سفارش‌گیری رستوران در حال رشد است یا افت کرده؛ مستقل از اینکه قیمت‌ها چه تغییری کرده‌اند.',
          'رشد تعداد سفارشات — تعریف: درصد تغییر تعداد سفارشات نسبت به دوره قبل. چرا مهم است؟ رشد یا افت واقعی «تقاضا» رستوران را نشان می‌دهد؛ جدا از بحث قیمت.',
          'میزان فروش — تعریف: مجموع مبلغ تمام سفارش‌های ثبت‌شده در آن ماه.',
          'رشد میزان فروش — تعریف: درصد تغییر مبلغ فروش نسبت به دوره قبل. چرا مهم است؟ مهم‌ترین شاخص برای رشد کسب‌وکار است، اما به‌تنهایی گمراه‌کننده است؛ چون رشد فروش می‌تواند فقط ناشی از افزایش قیمت باشد نه رشد واقعی کسب‌وکار. برای همین باید همیشه در کنار «رشد تعداد سفارشات» و «رشد قیمت» خوانده شود.',
          'مبلغ هر سفارش — تعریف: میانگین ارزش ریالی هر سفارش. نحوه محاسبه: میزان فروش کل تقسیم بر تعداد سفارشات. چرا مهم است؟ نشان می‌دهد به‌طور متوسط هر مشتری در هر بار مراجعه چقدر خرج می‌کند. این عدد حاصل تاثیر دو عامل است: «قیمت هر واحد کالا» و «تعداد اقلام هر سفارش». افزایش یا کاهش آن باید همیشه به یکی از این دو عامل (یا هر دو) نسبت داده شود.',
          'قیمت هر واحد کالا — تعریف: میانگین قیمت هر قلم کالای سفارش داده‌شده؛ نشان‌دهنده تورم منو یا تمایل مشتری به غذاهای گران‌تر/ارزان‌تر است. نحوه محاسبه: مجموع مبالغ آیتم‌های سفارش داده‌شده تقسیم بر تعداد آن‌ها.',
          'رشد قیمت — تعریف: درصد تغییر قیمت هر واحد کالا نسبت به دوره قبل. چرا مهم است؟ مشخص می‌کند رشد فروش، ناشی از افزایش نرخ منو (تورم) بوده یا رفتار انتخاب مشتری (رفتن به‌سمت آیتم‌های گران‌تر یا ارزان‌تر). اگر این رشد بالاتر از نرخ تورم واقعی هزینه‌های رستوران باشد، احتمال دارد مدیر منو قیمت‌ها را بیش از حد افزایش داده و در ریسک ریزش مشتری باشد؛ اگر پایین‌تر باشد، ممکن است رستوران عقب‌تر از تورم قیمت‌گذاری کرده و حاشیه سود از دست برود.',
          'تعداد اقلام هر سفارش — تعریف: به‌طور متوسط هر مشتری در یک سفارش چند قلم کالا خریده است (مثلاً غذا + نوشیدنی + دسر = ۳ قلم).',
          'رشد سبد — تعریف: درصد تغییر تعداد اقلام هر سفارش نسبت به دوره قبل. چرا مهم است؟ شاخص مستقیم موفقیت «فروش مکمل / آپ‌سل» است. رشد این عدد یعنی هر مشتری اقلام بیشتری در هر بار مراجعه خریداری می‌کند که مستقیماً روی سودآوری هر سفارش اثر مثبت دارد، بدون نیاز به جذب مشتری جدید.',
        ],
      },
      {
        title: 'تحلیل ترکیبی (رشد میزان فروش)',
        style: 'bullet',
        items: [
          'اگر رشد فروش > رشد تعداد سفارشات باشد: بخشی از رشد فروش، ناشی از افزایش ارزش هر سفارش است (یا گران‌تر شدن قیمت‌ها، یا سفارش اقلام بیشتر/گران‌تر توسط مشتری). باید به ستون‌های «رشد قیمت» و «رشد سبد» نگاه شود تا مشخص شود کدام‌یک عامل اصلی بوده است.',
          'اگر رشد فروش < رشد تعداد سفارشات باشد: یعنی هر سفارش نسبت به قبل ارزش کمتری دارد؛ یا تعداد اقلام هر سفارش کم شده، یا مشتری به‌سمت اقلام ارزان‌تر منو رفته است. این وضعیت هشدار می‌دهد که با وجود افزایش تقاضا، سودآوری هر سفارش در حال کاهش است.',
          'اگر رشد فروش ≈ رشد تعداد سفارشات باشد: رشد فروش کاملاً واقعی و ناشی از افزایش تعداد مشتری/سفارش است، نه تغییر قیمت یا رفتار خرید.',
        ],
      },
      {
        title: 'نحوه تفسیر (رشد سبد)',
        style: 'bullet',
        items: [
          'رشد سبد مثبت + رشد قیمت پایین یا منفی → رشد مبلغ هر سفارش ناشی از عملکرد خوب فروش مکمل است، نه گران‌فروشی. (نقطه قوت)',
          'رشد سبد منفی → باید در آموزش تیم سرویس برای پیشنهاد اقلام مکمل یا چیدمان منو بازنگری شود.',
        ],
      },
      {
        title: 'جمع‌بندی: نحوه خواندن این جدول در یک نگاه',
        style: 'decimal',
        items: [
          'اول به اشتراک‌گیری نگاه کنید؛ اگر زیر ۵۰٪ است، به بقیه اعداد مشتری‌محور با احتیاط زیاد نگاه کنید.',
          'رشد تعداد سفارشات را به‌عنوان شاخص واقعی رشد ترافیک/تقاضا در نظر بگیرید.',
          'رشد میزان فروش را همیشه در کنار رشد تعداد سفارشات بخوانید تا بفهمید رشد فروش «واقعی» است یا صرفاً ناشی از تغییر قیمت.',
          'اختلاف بین رشد فروش و رشد سفارشات را با دو عامل رشد قیمت و رشد سبد توضیح دهید تا مشخص شود چه چیزی محرک اصلی بوده است.',
        ],
      },
    ],
  },

  clubCustomerPerformanceTable: {
    title: 'راهنمای جدول «عملکرد باشگاه مشتریان»',
    description: 'این جدول عملکرد ماهانه سرویس باشگاه مشتریان (اعتبار/کش‌بک) رستوران را نشان می‌دهد؛ یعنی اینکه مشتریان چقدر از تخفیف/اعتباری که رستوران در قالب باشگاه مشتریان به آن‌ها می‌دهد استفاده می‌کنند.',
    interpretation: '',
    sections: [
      {
        title: 'تعریف ستون‌ها',
        style: 'decimal',
        items: [
          'اشتراک‌گیری — تعریف: درصد سفارشاتی که همراه با اطلاعات مشتری (شماره تماس) ثبت شده‌اند.',
          'تعداد سفارشات — تعریف: تعداد کل سفارش‌های ثبت‌شده در آن ماه (چه با اعتبار، چه بدون اعتبار).',
          'میزان فروش — تعریف: مجموع مبلغ سفارش‌های آن ماه؛ مبنای مقایسه برای سنجش سهم باشگاه مشتریان از کل فروش است.',
          'تعداد سفارش‌های با اعتبار — تعریف: تعداد سفارش‌هایی که مشتری در آن‌ها از اعتبار باشگاه مشتریان استفاده کرده است.',
          'درصد سفارش‌های با اعتبار — تعریف: چند درصد از کل سفارشات آن ماه با استفاده از اعتبار باشگاه پرداخت شده‌اند. نحوه محاسبه: تعداد سفارش‌های با اعتبار تقسیم بر تعداد کل سفارشات. چرا مهم است؟ نرخ نفوذ باشگاه مشتریان در کل فروش رستوران را نشان می‌دهد. هرچه بالاتر باشد، یعنی باشگاه مشتریان به بخش جدی‌تری از رفتار خرید مشتریان تبدیل شده است. نکته: در این ستون «هدف» برای هر شعبه وجود دارد؛ درصدی که شعبه باید به آن برسد و بر مبنای متعادل از بازار تعیین شده است، نه یک عدد دلخواه داخلی. با نگه‌داشتن نشانگر روی مقدار هر ماه، اختلاف عملکرد واقعی شعبه با این هدف نمایش داده می‌شود (مثال: «پایین‌تر از هدف» به همراه مقدار شعبه، مقدار هدف و میزان اختلاف). اگر عدد شعبه پایین‌تر از هدف باشد، یعنی باشگاه به‌درستی مورد استفاده قرار نمی‌گیرد؛ همین منطق برای «درصد اعتبار استفاده‌شده» هم برقرار است.',
          'مبلغ سفارش‌های با اعتبار — تعریف: مجموع مبلغ (ریالی) کل سفارش‌هایی که در آن‌ها اعتبار استفاده شده است (مبلغ کل آیتم ها).',
          'مبلغ اعتبار استفاده‌شده — تعریف: مجموع مبلغی که مشتریان از اعتبار/کش‌بک باشگاه مشتریان خود در پرداخت صورت‌حساب کسر کرده‌اند (نه کل مبلغ سفارش، فقط بخش تخفیف/اعتباری آن). چرا مهم است؟ این عدد در واقع «هزینه واقعی» اجرای باشگاه مشتریان برای رستوران در آن ماه است؛ یعنی چقدر از درآمد رستوران صرف اعتبار دادن به مشتریان شده است.',
          'درصد اعتبار استفاده‌شده — تعریف: چند درصد از کل فروش ماه، از طریق اعتبار باشگاه مشتریان پوشش داده شده است. نحوه محاسبه: مبلغ اعتبار استفاده‌شده تقسیم بر میزان فروش. چرا مهم است؟ شاخص «هزینه باشگاه مشتریان نسبت به فروش» است. اگر این درصد خیلی بالا برود، یعنی سهم قابل‌توجهی از فروش عملاً با تخفیف اعتبار پوشش داده شده و باید حاشیه سود مورد بررسی قرار گیرد. اگر خیلی پایین باشد (نزدیک صفر)، یعنی باشگاه مشتریان عملاً روی فروش تأثیر مالی محسوسی ندارد و باید روی چیدمان و استفاده از باشگاه و مبالغ اعتبار و یا عواملی که روی عملکرد باشگاه مثل اشتراک گیری تاثیر میگذارد بازنگری شود.',
          'تعداد مشتریان یکتا — تعریف: تعداد مشتریانی که در آن ماه حداقل یک‌بار از اعتبار باشگاه مشتریان خود استفاده کرده‌اند (هر مشتری فقط یک‌بار شمرده می‌شود، فارغ از تعداد دفعات استفاده). چرا مهم است؟ نشان می‌دهد باشگاه مشتریان چه تعداد مشتری واقعی و متمایز را درگیر کرده است؛ برخلاف «تعداد سفارش‌های با اعتبار» که ممکن است حاصل استفاده مکرر تعداد کمی مشتری باشد.',
        ],
      },
      {
        title: 'جمع‌بندی و تحلیل ترکیبی',
        style: 'decimal',
        items: [
          'مقایسه تعداد مشتریان یکتا با تعداد سفارش‌های با اعتبار (نرخ بازگشت مشتریان فعال باشگاه): تعداد سفارش‌های با اعتبار تقسیم بر تعداد مشتریان یکتا، میانگین دفعاتی است که هر مشتریِ عضو در ماه از اعتبارش استفاده کرده. عدد بالا نشانه‌ی خوب وفاداری‌ست: یعنی باشگاه مشتریان صرفاً یک تخفیف یک‌بارمصرف نیست، بلکه عادت بازگشت ساخته. اگر این عدد نزدیک ۱ باشد، یعنی هر مشتری فقط یک‌بار در ماه سراغ اعتبارش می‌آید و باشگاه هنوز به یک محرک بازگشت مستمر تبدیل نشده.',
          'نرخ نفوذ باشگاه در پایگاه مشتریان شناسایی‌شده: «تعداد مشتریان یکتا» این جدول را می‌توان در کنار حجم مشتریانی که در جدول «عملکرد فروش ماهانه» شناسایی شده‌اند (یعنی سفارش‌هایی که با شماره تماس ثبت شده‌اند) قرار داد. این مقایسه نشان می‌دهد از بین همه مشتریانی که رستوران شماره‌شان را دارد، چند درصد واقعاً عضو فعال باشگاه هستند. فاصله زیاد بین این دو عدد یعنی پتانسیل بزرگی برای دعوت مشتریان شناسایی‌شده به عضویت/فعال‌سازی باشگاه وجود دارد که هنوز استفاده نشده.',
          'پیوند با رشد سفارشات جدول فروش ماهانه (آیا باشگاه محرک رشد است؟): اگر در ماهی «درصد سفارش‌های با اعتبار» جهش کند و هم‌زمان «رشد تعداد سفارشات» در جدول فروش ماهانه هم مثبت و بالا باشد، می‌توان با احتیاط نتیجه گرفت بخشی از رشد ترافیک، محصول مستقیم باشگاه مشتریان بوده (مثلاً به‌خاطر یک کمپین)',
        ],
      },
    ],
  },

  categorySalesTrend: {
    title: 'راهنمای روند فروش دسته‌بندی محصولات',
    description: 'این نمودار روند فروش دسته‌های مختلف محصولات را در طول زمان نمایش می‌دهد.',
    interpretation: 'شناسایی دسته‌های در حال رشد و افت به تصمیم‌گیری بهتر کمک می‌کند.',
    tips: [
      'دسته‌های پرفروش را برای سودآوری بیشتر بهینه کنید',
      'دسته‌های در حال افت را بازنگری یا حذف کنید',
      'منو را بر اساس روندهای فروش به‌روزرسانی کنید'
    ]
  },

  // Club Conditions Dashboard Charts
  clubConditionsTable: {
    title: 'راهنمای جدول «عملکرد ماهانه شروط باشگاه مشتریان»',
    description: '',
    interpretation: '',
    sections: [
      {
        title: 'تعریف ستون‌ها',
        style: 'bullet',
        items: [
          'مبلغ کل سفارش: مجموع مبلغ ریالی همه سفارشات ثبت‌شده در آن ماه.',
          'مبلغ اعتبار تولید شده: مجموع مبلغ کل اعتبارهایی که در آن ماه تولید شده‌اند.',
          'مبلغ اعتبار استفاده شده: مجموع مبلغ‌های استفاده‌شده در همان ماه، فارغ از اینکه آن اعتبار در چه ماهی تولید شده باشد.',
          'تعداد کل سفارش: تعداد کل سفارشات ثبت‌شده در آن ماه.',
          'تعداد اعتبار تولیدی: تعداد کل اعتبارهایی که در آن ماه تولید شده‌اند.',
          'تعداد اعتبار مصرفی: تعداد اعتبارهایی که در همان ماه استفاده شده‌اند، فارغ از اینکه در چه ماهی تولید شده باشند.',
          'گیرندگان یکتا: تعداد مشتریانی که در آن ماه، حداقل یک‌بار اعتبار جدید دریافت کرده‌اند (هر مشتری فقط یک‌بار شمرده می‌شود).',
          'مصرف‌کنندگان یکتا: تعداد مشتریانی که در آن ماه، حداقل یک‌بار از اعتبار خود استفاده کرده‌اند (هر مشتری فقط یک‌بار شمرده می‌شود).',
        ],
      },
    ],
  },

  usedCreditRatioChart: {
    title: 'راهنمای بررسی هزینه واقعی باشگاه مشتریان',
    description: 'وقتی حس می‌کنید هزینه کش‌بک یا اعتبار باشگاه مشتریان «زیاد» شده، به‌جای قضاوت بر اساس حس کلی، این سه عدد را کنار هم ببینید. هر کدام یک سؤال متفاوت را جواب می‌دهند.',
    interpretation: '',
    sections: [
      {
        title: 'سؤال اول: «چقدر از فاکتورها اصلاً کش‌بک می‌گیرند؟»',
        style: 'none',
        items: [
          'شاخص: درصد اعتبار تولیدی نسبت به فاکتور',
          'فرمول: تعداد اعتبار تولیدشده ÷ تعداد کل فاکتور',
          'این عدد نشان می‌دهد چه سهمی از سفارشات، اصلاً وارد چرخه کش‌بک شده‌اند. اگر این عدد پایین باشد (مثلاً ۲۰ تا ۳۰ درصد)، یعنی اکثر مشتریان اصلاً این تجربه را نداشته‌اند؛ باشگاه مشتریان هنوز روی بخش کوچکی از فاکتورها اثر می‌گذارد. در این حالت باید اشتراک‌گیری و تنظیمات مربوط به کش‌بک بررسی شود تا مشخص شود علت پایین بودن این عدد کجاست.',
        ],
      },
      {
        title: 'سؤال دوم: «از اعتباری که داده شده، چقدرش واقعاً مصرف می‌شود؟»',
        style: 'none',
        items: [
          'شاخص: درصد مشارکت (تعدادی یا مبلغی)',
          'فرمول: مقدار مصرف‌شده از اعتبار تولیدشده یک ماه (تا امروز) ÷ مقدار اعتبار تولیدشده همان ماه',
          'این عدد نشان می‌دهد چه سهمی از اعتبارهایی که به مشتری تعلق گرفته، واقعاً به مصرف می‌رسد. بخشی از اعتبارهای مصرف‌نشده هم، پس از مدتی منقضی می‌شوند؛ یعنی تعهد واقعی رستوران همیشه کمتر از چیزی است که روی کاغذ داده شده.',
        ],
      },
      {
        title: 'سؤال سوم: «هزینه واقعی نسبت به کل فروش چقدر است؟»',
        style: 'none',
        items: [
          'شاخص: درصد اعتبار مصرف‌شده نسبت به فروش',
          'فرمول: مبلغ اعتبار مصرف‌شده ÷ میزان فروش',
          'این عدد نشان می‌دهد از کل درآمد رستوران، چه سهمی واقعاً صرف کش‌بک شده است؛ یعنی هزینه‌ای که واقعاً از جیب رستوران رفته، نه هزینه‌ای که فقط داده شده.',
        ],
      },
      {
        title: 'راهنمای بازه (تقریبی)',
        style: 'bullet',
        items: [
          'تا ۵٪ — معمولاً بی‌ضرر است',
          'بالای ۵٪ — نیاز به بررسی؛ باید با رشد بازگشت مشتری توجیه شود',
        ],
      },
      {
        title: 'جمع‌بندی: چطور این سه را با هم بخوانیم',
        style: 'none',
        items: [
          'این سه عدد، مثل سه لایه پشت‌سر‌هم، تصویر واقعی هزینه باشگاه مشتریان را می‌سازند:',
          '۱. اول ببینید چه سهمی از فاکتورها اصلاً وارد چرخه شده‌اند (سؤال اول).',
          '۲. بعد ببینید از همان بخش، چقدرش واقعاً مصرف شده (سؤال دوم).',
          '۳. در نهایت ببینید نتیجه نهایی این دو، چه سهمی از کل فروش را تشکیل می‌دهد (سؤال سوم).',
          'وقتی هر سه عدد پایین یا متوسط باشند، یعنی نگرانی از «زیاد بودن هزینه کش‌بک» معمولاً بزرگ‌تر از واقعیت است؛ چون هم دامنه اثرگذاری کوچک است (سؤال اول)، هم بخش زیادی از تعهد اصلاً مصرف نمی‌شود (سؤال دوم)، و در نهایت سهم آن از کل فروش هم کوچک باقی می‌ماند (سؤال سوم).',
        ],
      },
    ],
  },

  generatedCreditRatioChart: {
    title: 'راهنمای نمودار «تعداد اعتبار تولیدی به تعداد سفارش»',
    description: 'این نمودار نسبت تعداد اعتبار تولیدی به تعداد کل سفارش را در هر بازه زمانی نشان می‌دهد؛ یعنی از کل سفارشات آن ماه، به ازای چه سهمی از آن‌ها اعتبار جدید برای مشتری تولید شده است.',
    interpretation: 'تعداد اعتبار تولیدی به تعداد سفارش = تعداد اعتبار تولیدی همان ماه ÷ تعداد کل سفارش همان ماه. خط قرمز روی نمودار هم روند کلی این نسبت را در طول ماه‌های اخیر نشان می‌دهد.',
  },

  generatedCreditAmountRatioChart: {
    title: 'راهنمای مبلغ اعتبار تولیدی به سفارش',
    description: 'این نمودار نسبت مبلغ اعتبار تولیدی به مبلغ کل سفارش را نمایش می‌دهد.',
    interpretation: 'درصد بالاتر نشان‌دهنده سخاوتمندی بیشتر برنامه وفاداری است.',
    tips: [
      'تعادل بین سخاوت و سودآوری را حفظ کنید',
      'با رقبا مقایسه و تنظیم کنید',
      'اثر تغییرات نرخ را بر وفاداری بررسی کنید'
    ]
  },

  participationRateChart: {
    title: 'راهنمای نمودار «درصد مشارکت تعدادی شروط»',
    description: 'این نمودار نشان می‌دهد از تعداد اعتبارهایی که در یک ماه مشخص تولید شده‌اند، تا امروز چند عدد از آن‌ها مصرف شده‌اند؛ فارغ از اینکه این مصرف در همان ماه اتفاق افتاده باشد یا در ماه‌های بعد.',
    interpretation: 'درصد مشارکت تعدادی = تعداد اعتبارهای مصرف‌شده از اعتبار تولیدی آن ماه (تا امروز) ÷ تعداد اعتبار تولیدی همان ماه. خط قرمز روی نمودار هم روند کلی این درصد را در طول ماه‌های اخیر نشان می‌دهد.',
  },

  participationAmountChart: {
    title: 'راهنمای نمودار «درصد مشارکت مبلغی شروط»',
    description: 'این نمودار نشان می‌دهد از میزان اعتباری که در یک ماه مشخص تولید شده، تا امروز چه سهمی مصرف شده است؛ فارغ از اینکه آن مصرف در همان ماه اتفاق افتاده باشد یا در ماه‌های بعد. یعنی اعتبار تولیدشده در یک ماه را دنبال می‌کند تا ببیند در نهایت چه بخشی از آن خرج شده است، نه فقط مصرف هم‌زمان با تولید.',
    interpretation: 'درصد مشارکت مبلغی = مبلغ مصرف‌شده از اعتبار تولیدشده آن ماه (تا امروز) ÷ مبلغ اعتبار تولیدی همان ماه. خط قرمز روی نمودار هم روند کلی این درصد را در طول ماه‌های اخیر نشان می‌دهد.',
  },

  // نبض بازار (Market Pulse)
  marketPulseKpi: {
    title: 'راهنمای نتایج مقایسه کسب کار شما با کسب کار های متصل بازار',
    description: 'این بخش چهار شاخص کلیدی — رشد فروش، تعداد سفارش، رشد قیمت (میانگین قیمت منو) و سبد — را برای دورهٔ انتخاب‌شده مقایسه می‌کند: ابتدا رشد شعبه، سپس رشد بازار، و در پایان وضعیت نسبی (جلوتر / عقب‌تر / هم‌تراز بازار) به‌همراه مقدار اختلاف (بر حسب درصد).',
    interpretation: 'روی هر کارت ابتدا مقدار شعبه و بازار را ببینید؛ برچسب وضعیت («جلوتر از بازار»، «عقب‌تر از بازار» یا «هم‌تراز بازار») موقعیت نسبی شما را نشان می‌دهد و عدد زیر آن اختلاف رشد شعبه نسبت به بازار است. اگر دادهٔ شعبه ناقص باشد، هشدار پوشش داده نمایش داده می‌شود و در حالت تخمین، مقادیر تا پایان ماه تخمین زده می‌شوند.',
    tips: [
      'به چهار شاخص هم‌زمان نگاه کنید — عملکرد قوی در فروش ممکن است با ضعف سبد همراه باشد',
      'اگر هشدار «داده کامل نیست» دیدید، ماه‌های ناقص را در پنل بالای کارت‌ها بررسی کنید',
      'با تنظیم «تخمینی» می‌توانید شاخص‌ها را بر اساس کل ماه ببینید',
      'بازار از میانگین تجمیعی ناشناس همه‌ی رستوران‌ها ساخته شده — موقعیت نسبی شما را نشان می‌دهد'
    ]
  },

  marketPulseTable: {
    title: 'راهنمای جدول «مقایسه‌ی رشد ماهانه شعبه با  کسب‌وکارهای متصل بازار »',
    description: 'این جدول رشد ماه‌به‌ماه شاخص‌های کلیدی شعبه را در کنار «کل بازار» (میانگین تجمیعی و ناشناس همه‌ی بازار) و اختلاف آن‌ها (بر حسب واحد درصد) نمایش می‌دهد. چهار شاخص قابل انتخاب است: فروش، سفارش، قیمت، سبد؛ و برای هرکدام سه ستون دیده می‌شود: بازار، اختلاف، و شعبه. دو دکمه هم بالای جدول قرار دارد: «با ستون بازار» که ستون بازار را نمایش می‌دهد یا مخفی می‌کند، و «فقط اختلاف» که فقط ستون اختلاف را نشان می‌دهد. برخی سطرها به‌جای عدد، آیکون چشم و برچسب «داده محدود» دارند؛ این یعنی داده آن ماه یا ماه قبلی‌اش کامل نبوده است.',
    interpretation: 'اختلاف مثبت یعنی شعبه از بازار جلوتر است و اختلاف منفی یعنی عقب‌تر. ستون «بازار» فقط میانگین تجمیعی را نشان می‌دهد — هیچ‌کس فروش دقیق کسی را نمی‌بیند، ولی همه از روند کلی بازار خبر دارند.',
    sections: [
      {
        title: 'چرا مهم است؟',
        style: 'none',
        items: [
          'بدون این جدول، رشد یا افت یک شعبه فقط با گذشته خودش مقایسه می‌شود؛ یعنی اگر فروش شعبه ۱۰٪ افت کند، معلوم نیست این افت مشکل خاص همان شعبه بوده یا کل بازار در آن ماه با رکود مواجه بوده است. این جدول با اضافه‌کردن معیار «بازار»، به شعبه اجازه می‌دهد بفهمد عملکردش نسبت به شرایط واقعی بازار چطور بوده، نه فقط نسبت به ماه قبل خودش.',
        ],
      },
      {
        title: 'نکات کاربردی',
        style: 'bullet',
        items: [
          'همان منطق ترکیبی رشد فروش، سفارش، قیمت و سبد که برای تشخیص محرک واقعی رشد به کار می‌رود، باید در سطح «اختلاف با بازار» هم تکرار شود: اگر اختلاف رشد فروش شعبه با بازار مثبت باشد ولی اختلاف رشد تعداد سفارش منفی، یعنی برتری شعبه نسبت به بازار بیشتر از محل قیمت یا سبد آمده، نه از محل جذب سفارش بیشتر نسبت به رقبا.',
          'اختلاف مثبت همیشه به معنای رشد مطلق نیست؛ ممکن است شعبه هم افت کرده باشد، ولی چون افت بازار بیشتر بوده، اختلاف مثبت ثبت شود. برای تصمیم‌گیری درست، باید هم عدد «شعبه» و هم «اختلاف» را با هم دید، نه فقط یکی از آن‌ها.',
          'سطرهای با برچسب «داده محدود» نباید برای مقایسه یا نتیجه‌گیری استفاده شوند؛ باید صبر کرد تا داده آن ماه کامل شود، مگر با استفاده از گزینه تخمین (توضیح زیر).',
        ],
      },
      {
        title: 'گزینه تخمین برای ماه‌های با داده محدود',
        style: 'none',
        items: [
          'برای ماه‌هایی که داده محدود دارند، یک گزینه «تخمین» وجود دارد: با فعال کردن آن، داده موجود بر تعداد روزهایی که داده دارد تقسیم می‌شود (میانگین روزانه به دست می‌آید) و سپس این میانگین به کل روزهای ماه تعمیم داده می‌شود.',
          'حداقل تعداد روز لازم برای استفاده از این تخمین: چون رفتار خرید مشتری در هفته اول ماه با آخر ماه، و در تعطیلات و آخر هفته‌ها با روزهای عادی هفته، طبیعتاً متفاوت است، تخمین فقط زمانی قابل اعتماد است که داده موجود، بخش بزرگی از این الگوهای متفاوت را پوشش دهد؛ در غیر این صورت، اگر روزهای موجود تصادفاً همه شلوغ یا همه خلوت باشند (مثلاً فقط آخر هفته‌ها یا فقط هفته اول ماه)، تخمین کل ماه به همان سمت منحرف می‌شود.',
        ],
      },
      {
        title: 'راهنمای اعتماد به تخمین (بر اساس تعداد روز)',
        style: 'bullet',
        items: [
          'زیر ۷ روز — تخمین غیرقابل اعتماد؛ حتی چرخه هفتگی هم کامل نشده',
          '۷ تا ۱۴ روز — حداقل قابل استفاده، ولی همچنان در معرض تورش «هفته اول/آخر ماه»؛ باید با احتیاط خوانده شود',
          '۱۴ تا ۲۱ روز — قابل قبول؛ بخش بیشتری از الگوی ماه پوشش داده شده',
          'بالای ۲۱ روز — تخمین قابل اعتماد',
        ],
      },
    ],
  },

  marketPulseYoYTable: {
    title: 'راهنمای جدول «مقایسه‌ی رشد سال‌به‌سال شعبه با  کسب‌وکارهای متصل بازار »',
    description: 'این جدول رشد نسبت به ماه مشابه سال قبل را برای شعبه، در کنار همان رشد برای کل  کسب‌وکارهای متصل بازار ، نمایش می‌دهد؛ یعنی مثلاً مرداد امسال با مرداد سال قبل مقایسه می‌شود، نه با تیر امسال. ساختار جدول دقیقاً مثل جدول «مقایسه‌ی رشد ماهانه» است: همان چهار شاخص (فروش، سفارش، قیمت، سبد)، همان سه ستون (بازار، اختلاف، شعبه)، و همان دکمه‌های «با ستون بازار» و «فقط اختلاف».',
    interpretation: 'دقیقاً مثل جدول ماهانه: اختلاف مثبت یعنی شعبه از بازار جلوتر است و اختلاف منفی یعنی عقب‌تر، با این تفاوت که این بار «جلوتر یا عقب‌تر بودن» به رشد یک‌ساله اشاره دارد، نه رشد یک‌ماهه.',
    sections: [
      {
        title: 'چرا مهم است؟',
        style: 'none',
        items: [
          'جدول ماهانه، ماه را با ماه قبل از خودش مقایسه می‌کند؛ این یعنی اگر یک ماه به‌طور طبیعی پررونق‌تر یا کم‌رونق‌تر از ماه قبلش باشد (مثل فروردین یا فصل تابستان)، عدد رشد ماهانه گمراه‌کننده می‌شود، چون این تفاوت فصلی را با رشد یا افت واقعی قاطی می‌کند. جدول سال‌به‌سال این مشکل را حل می‌کند: چون هر ماه را با همان ماه در سال قبل مقایسه می‌کند، اثر فصلی از هر دو طرف مقایسه حذف می‌شود و آنچه باقی می‌ماند، رشد یا افت واقعی کسب‌وکار در طول یک سال است.',
        ],
      },
      {
        title: 'داده محدود و گزینه تخمین',
        style: 'none',
        items: [
          'برخی سطرها به‌جای عدد، آیکون چشم و برچسب «داده محدود» دارند. در این جدول، چون هر مقایسه به دو نقطه داده وابسته است (ماه جاری و همان ماه در سال قبل)، احتمال برخورد با داده محدود بیشتر از جدول ماهانه است؛ کافی است یکی از این دو ماه ناقص باشد تا کل مقایسه محدود شود.',
          'برای این حالت هم گزینه «تخمین» وجود دارد: داده موجود بر تعداد روزهایی که داده دارد تقسیم می‌شود (میانگین روزانه به دست می‌آید) و این میانگین به کل روزهای ماه تعمیم داده می‌شود. چون رفتار خرید مشتری در هفته اول ماه با آخر ماه، و در تعطیلات و آخر هفته‌ها با روزهای عادی هفته متفاوت است، اعتبار این تخمین به تعداد روزهای موجود بستگی دارد:',
        ],
      },
      {
        title: 'راهنمای اعتماد به تخمین (بر اساس تعداد روز)',
        style: 'bullet',
        items: [
          'زیر ۷ روز — تخمین غیرقابل اعتماد؛ حتی چرخه هفتگی هم کامل نشده',
          '۷ تا ۱۴ روز — حداقل قابل استفاده، ولی همچنان در معرض تورش «هفته اول/آخر ماه»؛ باید با احتیاط خوانده شود',
          '۱۴ تا ۲۱ روز — قابل قبول؛ بخش بیشتری از الگوی ماه پوشش داده شده',
          'بالای ۲۱ روز — تخمین قابل اعتماد',
        ],
      },
      {
        title: 'تحلیل ترکیبی: رشد از کجا آمده، نسبت به بازار',
        style: 'none',
        items: [
          'همان‌طور که در جدول ماهانه، اختلاف رشد فروش باید کنار اختلاف رشد سفارش، قیمت و سبد خوانده شود تا مشخص شود منشأ رشد چیست، همین منطق در سطح سال‌به‌سال و در مقایسه با بازار هم باید تکرار شود:',
        ],
      },
      {
        title: 'سناریوهای تحلیل ترکیبی',
        style: 'bullet',
        items: [
          'اگر اختلاف رشد فروش شعبه با بازار مثبت باشد و اختلاف رشد تعداد سفارش هم مثبت باشد، یعنی برتری شعبه نسبت به بازار واقعاً از افزایش ترافیک و جذب سفارش بیشتر آمده، نه صرفاً از تغییر قیمت.',
          'اگر اختلاف رشد فروش مثبت باشد ولی اختلاف رشد تعداد سفارش منفی یا نزدیک صفر باشد، یعنی برتری شعبه نسبت به بازار بیشتر از محل قیمت یا سبد بوده؛ در این حالت باید به اختلاف رشد قیمت و اختلاف رشد سبد جداگانه نگاه کرد تا مشخص شود کدام‌یک سهم بیشتری داشته.',
          'اگر اختلاف رشد قیمت بزرگ‌تر باشد، یعنی شعبه توانسته گران‌تر از رقبا قیمت‌گذاری کند یا مشتری را به‌سمت اقلام گران‌تر (نسبت به روند کلی بازار) ببرد.',
          'اگر اختلاف رشد سبد بزرگ‌تر باشد، یعنی شعبه نسبت به بازار در فروش مکمل (افزایش تعداد اقلام هر سفارش) موفق‌تر عمل کرده است.',
          'اگر اختلاف رشد فروش منفی باشد ولی اختلاف رشد تعداد سفارش مثبت باشد، یعنی شعبه نسبت به بازار در جذب سفارش بهتر عمل کرده، ولی ارزش هر سفارش (قیمت یا سبد) نسبت به روند بازار عقب مانده است.',
          'این تحلیل، برخلاف نگاه ساده به یک عدد رشد فروش، مشخص می‌کند برتری یا ضعف شعبه نسبت به بازار، دقیقاً از کدام جزء (ترافیک، قیمت، یا سبد) ناشی شده است.',
        ],
      },
    ],
  },

  marketPulseTrend: {
    title: 'راهنمای روند مقایسه‌ای شعبه و بازار',
    description: 'این نمودار میله‌ای، درصد رشد ماه‌به‌ماه شاخص انتخاب‌شده را برای شعبه و کل بازار (میانگین تجمیعی ناشناس) در طول دوره مقایسه می‌کند.',
    interpretation: 'مقادیر بالای خط صفر رشد مثبت و پایین آن رشد منفی‌اند. میله‌ی «بازار» بازتاب روند جمعی صنعت است — نه عملکرد یک رقیب؛ شما فقط موقعیت نسبی خودتان را می‌بینید.',
    tips: [
      'با دکمه‌های بالای نمودار، شاخص مورد نظر را تغییر دهید',
      'به فاصله‌ی میله‌ی شعبه و بازار در هر ماه توجه کنید',
      'روند صعودی پایدار نسبت به بازار، مزیت رقابتی پایدار را نشان می‌دهد',
      'این بنچمارک از مشارکت جمعی ساخته شده و برای مشتریان فعلی رایگان است'
    ]
  },
};
